import { yupResolver } from "@hookform/resolvers/yup";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Box,
  Modal,
  TextField,
  Tooltip,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";

import {
  areaDropDown,
  cityDropDown,
  countryDropDown,
  districtDropDown,
  stateDropDown,
  talukaDropDown,
} from "../../areas/area/AreaServices";
import {
  genderDropDown,
  relationDropdown,
  unitDropDown,
} from "../../../../commonServices/CommonService";
import {
  departmentDropdownList,
  occupationDropdown,
  EmployeeCategoryDropDown,
  EmployeeDropDown,
} from "../../../services/employee/DoctorService";
import {
  EmpcategoryDropdown,
  EmpclassificationDropdown,
  doctorSearchDropDown,
  getBirthDateAPI,
  getDoctorDetail,
  postEmployee,
} from "../../../services/employee/EmployeeService";
import {
  bankDropdown,
  bloodGroupDropdown,
  degreeDropdown,
  designationDropdown,
  maritalStatusDropdown,
  motherTonghDropdown,
  prefixDropdown,
  religionDropdown,
} from "../../../services/referalDoctor/ReferalDoctorServices";


// import EmployeeBenefitModel from "./EmployeeBenefitModel";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import InputField from "../../../../common/components/FormFields/InputField";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputLimit from "../../../../common/components/FormFields/InputLimit";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import { History, Photo, Sign } from "../../../../assets/CommonAssets";
import { errorAlert, successAlert, warningAlert } from "../../../../common/components/Toasts/CustomToasts";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import RadioField from "../../../../common/components/FormFields/RadioField";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";

export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  // height:"90%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  boxShadow: 20,
};
const staffoption = [
  {
    id: "staff",
    value: "staff",
    label: "Staff",
  },
  {
    id: "Polyclinic",
    value: "Polyclinic",
    label: "Polyclinic",
  },
  {
    id: "Nursing",
    value: "Nursing",
    label: "Nursing",
  },
];

const EmployeeBenefits = [
  {
    id: "creditAmount",
    value: "creditAmount",
    label: "Credit Amount",
  },
  {
    id: "groupwisebenefit",
    value: "groupwisebenefit",
    label: "Group wise benefit",
  },
];
const MedicalAllowance = [
  {
    id: "yes",
    value: "yes",
    label: "Yes",
  },
  {
    id: "no",
    value: "no",
    label: "No",
  },
];

const accountType = [
  {
    id: "saving",
    value: "saving",
    label: "Saving",
  },
  {
    id: "current",
    value: "current",
    label: "Current",
  },
];
const benefitTypes = [
  {
    id: "other",
    value: "other",
    label: "Other",
  },
  {
    id: "insurance",
    value: "insurance",
    label: "Insurance",
  },
  {
    id: "free",
    value: "free",
    label: "Free",
  },
];
const EmployeeBenefitsData = [
  {
    id: 1,
    Group: "OPD",
    AmountPerYear: "",
    ConsumeAmt: 0,
    BalanceAmt: "",
  },
  {
    id: 2,
    Group: "IPD",
    AmountPerYear: "",
    ConsumeAmt: 0,
    BalanceAmt: "",
  },
  {
    id: 3,
    Group: "Pharmacy",
    AmountPerYear: "",
    ConsumeAmt: 0,
    BalanceAmt: "",
  },
];
const SalaryModeArr = [
  {
    id: 1,
    label: "Cheque",
    value: "cheque",
  },
  {
    id: 2,
    label: "Cash",
    value: "cash",
  },
  {
    id: 3,
    label: "Bank",
    value: "bank",
  },
];

const degreeArray = [
  { id: 1, label: "MCA", value: 1 },
  { id: 2, label: "BCA", value: 2 },
  { id: 3, label: "BBA", value: 3 },
];
export default function EmployeeModel(props) {
  const inputFile = useRef(null);
  const [file, setFile] = useState(null);
  const [uploadfile, setUploadFile] = useState(null);
  const [regDate, setRegDate] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [issueDate, setIssueDate] = useState(null);
  const [lastworking, setLastWorking] = useState();
  const [dateofBirth, setDateOfBirth] = useState(new Date());
  const [dateofBirths, setDateOfBirths] = useState(new Date());
  const [countryOption, setCountryOption] = useState([]);
  const [dateOfAnniversary, setDateOfAnniversary] = useState(null);
  const [dateOfJoining, setDateOfJoining] = useState(null);
  const [fromToDate, setFromToDate] = useState(new Date());
  const [fromToDateEmp, setFromToDateEmp] = useState(new Date());
  const [toDate, SetToDate] = useState(new Date());
  const [toDateEmp, setToDateEmp] = useState(new Date());
  const [prefixOption, setPrefixOption] = useState([]);
  const [religionOption, setReligionOption] = useState([]);
  const [motherTonghOption, setMotherTonghOption] = useState([]);
  const [designationOption, setDesignationOptions] = useState([]);
  const [classificationOption, setClassificationOption] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [degreeOption, setDegreeOption] = useState([]);
  const [bankOption, setBankOption] = useState([]);
  const [countryId, setCountryId] = useState();
  const [stateOption, setStateOption] = useState([]);
  const [stateId, setStateId] = useState();
  const [districtOption, setDistrictOption] = useState([]);
  const [talukaOptions, settalukaOptions] = useState([]);
  const [districtId, setDistrictId] = useState();
  const [cityOption, setCityOption] = useState([]);
  const [cityId, setCityId] = useState();
  const [areaOption, setAreaOption] = useState([]);
  const [finalData, setFinalData] = React.useState();
  const [openPost, setOpenPost] = React.useState(false);
  const [openPut, setOpenPut] = React.useState(false);
  const [unitOption, setUnitOption] = React.useState([]);
  const [bloodGroupOption, setbloodGroupOption] = useState([]);
  const [maritalStatusOption, setMaritalStatusOption] = useState([]);
  const [genderOption, setGenderOption] = React.useState([]);
  const [relationOption, setRelationOption] = useState([]);
  const [occupationOption, setOccupationOption] = useState([]);
  const [departmentOption, setDepartMentOption] = useState([]);
  const [eduData, setEduData] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [dependentData, setDependentData] = useState([]);
  const [classificationId, setClassificationId] = useState();
  const [CategoryId, setCategoryId] = useState();
  const [reportingToId, setreportingToId] = useState();
  const [doctorId, setDoctorId] = useState();
  const [doctorData, setDoctorData] = useState({});
  const [photoData, setPhotoData] = useState();
  const [resetKey, setResetKey] = useState(0);
  const [signData, setSignData] = useState();
  const [referenceData, setReferenceData] = useState([]);
  const [categoryOption, setCategoryOption] = useState([]);
  const [reportingToOption, setreportingToOption] = useState([]);
  const [doctorOption, setDoctorOption] = useState([]);
  const [open, setOpen] = useState(false);
  const [empBenefitsHistory, setEmpBenefitHistory] = useState();
  const [empClassification, setEmpClassification] = useState([]);

  const handleOpen = () => {
    reset(defaultValues);
    setFile(null);
    setUploadFile(null);
    setPhotoData(null);
    setSignData(null);
    setIssueDate(null);
    setExpiryDate(null);
    setLastWorking(null);
    setRegDate(null);
    props.setEdit(false);
    props.setEditDataFetch(null);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  const handleClosePut = () => {
    if (openPut) {
      setOpenPut(false);
    }
  };

  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
    }
  };
  const schema = yup.object().shape({
    unit: yup
      .object()
      .nullable()
      .required("Required")

      .shape({
        value: yup.string().required("Please Select Item Category"),
        label: yup.string().required("Please Select Item Category"),
      }),

    firstName: yup
      .string()
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Please Give First Name in Proper Format"
      )
      .required("Required")
      .min(1),
    lastName: yup.string().required("Required"),
    address: yup.string().required("Required"),
    localaddress: yup.string().required("Required"),
    privateClinicAddress: yup.string().required("Required"),

    emailID: yup.string().email().required(),
    mobileNo: yup
      .string()
      .matches(/^[0-9]+$/, "Please Provide Valid Mobile No.")
      .min(10, "Please Provide Valid Mobile No.")
      .max(10, "Please Provide Valid Mobile No.")
      .required("Please Provide Valid Mobile No."),
    panNo: yup
      .string()
      .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Required ")
      .min(10, "Please Provide Valid Pan No.")
      .max(10, "Please Provide Valid Pan No.")
      .required("Required"),
    IFSCCode: yup
      .string()
      .matches(/^[A-Z]{4}0[0-9]{6}$/, "Required ")
      .min(11, "Please Provide Valid IFSC Code.")
      .max(11, "Please Provide Valid IFSC Code.")
      .required("Required"),

    PFNo: yup
      .string()
      .matches(/^[A-Z]{5}[0-9]{12}$/, "Required ")
      .min(17, "Please Provide Valid IFSC Code.")
      .max(17, "Please Provide Valid IFSC Code.")
      .required("Required"),
    eSINo: yup
      .string()
      .matches(/^[0-9]{17}$/, "Required ")
      .min(17, "Please Provide Valid IFSC Code.")
      .max(17, "Please Provide Valid IFSC Code.")
      .required("Required"),
    // pinCode: yup
    //   .number()
    //   .min(6, "Please Provide Valid IFSC Code.")
    //   .max(6, "Please Provide Valid IFSC Code.")
    //   .required("Required"),
    // localPinCode:yu
    // .string()
    // .matches(
    //    /^[1-9]{1}[0-9]{2}\\s{0, 1}[0-9]{3}$/,
    //   "Required "
    // )
    // .min(6, "Please Provide Valid IFSC Code.")
    // .max(6, "Please Provide Valid IFSC Code.")
    // .required("Required"),
    pinCode: yup.string().test((val) => {
      if (val !== "0") return val?.length === 6;
    }),
    localPinCode: yup.string().test((val) => {
      if (val !== "0") return val?.length === 6;
    }),
  });


  const commonDatePickerSx = {
    backgroundColor: "white",

    "& .MuiOutlinedInput-root": {
      height: "40px",
    },

    "& .MuiOutlinedInput-input": {
      padding: "10px 12px", // ✅ THIS centers text
      fontSize: "14px",
      boxSizing: "border-box",
    },

    "& .MuiInputLabel-root": {
      fontSize: "13px",
    },

    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)", // ✅ proper label position
    },

    "& svg": {
      fontSize: 20,
      color: "#1E3A8A",
    },
  };

  const defaultValues = {
    status: false,
    unit: null,
    unitClassification: null,
    unitDepartment: null,
    unitMainDepartment: null,
    unitSubDepartment: null,
    privateOPD: false,
    OPD: false,
    IPD: false,
    investigation: false,
    noReference: false,
    procedure: false,
    RenewalDates: new Date(),
    RenewalDate: new Date(),
    dateofBirth: null,
    dateofBirth: null,
    dateOfJoining: null,
    dateOfAnniversary: null,
    fromDate: null,
    toDate: null,
    dateOfBirths: null,
    Medical: "yes",
    employeeCode: "",
    prefix: null,
    firstName: "",
    middleName: "",
    lastName: "",
    yy: "",
    mm: "",
    dd: "",
    religion: null,
    motherTongh: null,
    bloodGroup: null,
    maritalStatus: null,
    ClinicName: "",
    panNo: "",
    telephoneNo: "",
    mobileNo: "",
    emailID: "",
    passportNo: "",
    regNo: "",
    mahRegNo: "",
    designation: null,
    classification: null,
    specialization: null,
    subSpecialization: null,
    address: "",
    country: null,
    state: null,
    district: null,
    pinCode: "",
    city: null,
    area: null,
    addresslocal: false,
    localaddress: "",
    localCountry: null,
    localState: null,
    localDistrict: null,
    localPinCode: "",
    localCity: null,
    localArea: null,
    privateClinicContactNo: "",
    privateClinicAddress: "",
    degree: null,
    yearofPassing: "",
    university: "",
    classMarks: "",
    printApplicable: false,
    experienceyy: "",
    experiencemm: "",
    lastSalaryDrawn: "",
    postHeld: "",
    company: "",
    reasonForleaving: "",
    BankName: null,
    branchName: "",
    ACNo: "",
    IFSCCode: "",
    accountType: "saving",
    dependentFirstName: "",
    dependentMiddleName: "",
    dependentLastName: "",
    dependentGender: null,
    dependentAge: "",
    dependentRelation: null,
    dependentOccupation: null,
    taluka: null,
    localtaluka: null,
    employeeBenefit: "creditAmount",
    benefitType: null,

    issueDate: null,
    expiryDate: null,
    lastWorking: null,
    regDate: null,

    issueDate: new Date(),
    expiryDate: new Date(),
    lastWorking: new Date(),
    regDate: new Date(),

    validFrom: new Date(),
    validTill: new Date(),
    accessCardNo: "",
    department: null,
    eSINo: "",
    extensionNo: "",
    issuePlace: "",
    PFNo: "",
    reportingTo: "",
    fromDateEmp: null,
    toDateEmp: null,
    employeeName: "",
    companyName: "",
    positionHeld: "",
    address: "",
    employeeName: "",
    companyName: "",
    positionHeld: "",
    address: "",
    salaryMode: null,
    referenceAddress: "",
    EmployeeType: null,
    isDoctor: false,
    searchDoctor: null,
  };
  const {
    control,
    handleSubmit,
    watch,
    register,
    setValue,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    // resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  let experienceyyWatch = watch("experienceyy");
  let experiencemmWatch = watch("experiencemm");
  let lastSalaryDrawneWatch = watch("lastSalaryDrawn");
  let postHeldWatch = watch("postHeld");
  let companyWatch = watch("company");
  let reasonForleavingWatch = watch("reasonForleaving");
  let degreeWatch = watch("degree");
  let yearofPassingWatch = watch("yearofPassing");
  let universityWatch = watch("university");
  let classMarksWatch = watch("classMarks");
  let printApplicableWatch = watch("printApplicable");
  let dependentFirstNameWatch = watch("dependentFirstName");
  let dependentMiddleNameWatch = watch("dependentMiddleName");
  let dependentLastNameWatch = watch("dependentLastName");
  let dependentGenderWatch = watch("dependentGender");
  let dependentAgeWatch = watch("dependentAge");
  let dependentRelationWatch = watch("dependentRelation");
  let dependentOccupationWatch = watch("dependentOccupation");
  let MedicalWatch = watch("Medical");
  let addressWatch = watch("address");
  let countryWatch = watch("country");
  let stateWatch = watch("state");
  let districtWatch = watch("district");
  let talukaWatch = watch("taluka");
  let cityWatch = watch("city");
  let AreaWatch = watch("area");
  let pinCodeWatch = watch("pinCode");
  let salaryModeWatch = watch("salaryMode");
  let searchDoctorWatch = watch("searchDoctor");
  let EmployeeNameWatch = watch("employeeName");
  let CompanyNameWatch = watch("companyName");
  let PositionHeldWatch = watch("positionHeld");
  let AddressWatch = watch("referenceAddress");
  let isDoctorWatch = watch("isDoctor");
  let StaffWatch = watch("Staff");
  let accountTypeWatch = watch("accountType");
  let UnitWatch = watch("unit");
  let unitClassificationWatch = watch("unitClassification");
  let unitDepartmentWatch = watch("unitDepartment");
  let employeeBenefitWatch = watch("employeeBenefit");
  let benefitTypeWatch = watch("benefitType");
  let statusWatch = watch("status");

  //Photo Input Field HandleChange Function
  // const handleChange = (e) => {
  //   let arr = e.target.files;
  //   let imageUrl = URL.createObjectURL(e.target.files[0]);
  //   setFile(imageUrl);
  //   // let documentsArr = [...file];
  //   for (let obj of arr) {
  //     let object = {};
  //     object.empPhotoName = obj.name;
  //     object.size = obj.size;
  //     let reader = new FileReader();
  //     reader.readAsDataURL(obj);
  //     reader.onload = function () {
  //       let string = reader.result
  //         .toString()
  //         .replace("data:image/png;base64,", "");
  //       object.empPhotoBase64 = string;
  //     };
  //     setPhotoData(object);
  //   }
  // };


  //Sign Input Field HandleChange Function
  // const handleChangeClick = (e) => {
  //   let arr = e.target.files;
  //   let imageUrl = URL.createObjectURL(e.target.files[0]);
  //   setUploadFile(imageUrl);
  //   // let documentsArr = [...file];
  //   for (let obj of arr) {
  //     let object = {};
  //     object.empSignName = obj.name;
  //     object.size = obj.size;
  //     let reader = new FileReader();
  //     reader.readAsDataURL(obj);
  //     reader.onload = function () {
  //       if (!reader.result) return;  // ✅ IMPORTANT

  //       let string = reader.result
  //         .toString()
  //         .replace("data:image/png;base64,", "");

  //       object.empSignBase64 = string;

  //       setSignData(object); // ✅ move inside
  //     };
  //   }
  // };


  const handleChange = (e) => {
    const files = e.target.files;

    if (!files || files.length === 0) return; // ✅ FIX

    let imageUrl = URL.createObjectURL(files[0]);
    setFile(imageUrl);

    for (let obj of files) {
      let object = {
        empPhotoName: obj.name,
        size: obj.size,
      };

      let reader = new FileReader();

      reader.onload = function () {
        let base64 = "";

        if (typeof reader.result === "string") {
          base64 = reader.result.replace("data:image/png;base64,", "");
        }

        object.empPhotoBase64 = base64;
        setPhotoData(object);
      };

      reader.readAsDataURL(obj);
    }
  };

  const handleChangeClick = (e) => {
    const files = e.target.files;

    if (!files || files.length === 0) return; // ✅ FIX

    let imageUrl = URL.createObjectURL(files[0]);
    setUploadFile(imageUrl);

    for (let obj of files) {
      let object = {
        empSignName: obj.name,
        size: obj.size,
      };

      const reader = new FileReader();

      reader.onload = function () {
        if (!reader.result) return;
        let base64 = "";

        if (typeof reader.result === "string") {
          base64 = reader.result.replace("data:image/png;base64,", "");
        }

        object.empSignBase64 = base64;
        setSignData(object);
      };

      reader.readAsDataURL(obj);
    }
  };

  // Count The Experience  Year And Month
  var df = new Date(fromToDate);
  var dt = new Date(toDate);
  var allMonths =
    dt.getMonth() - df.getMonth() + 12 * (dt.getFullYear() - df.getFullYear());
  var allYears = dt.getFullYear() - df.getFullYear();
  var partialMonths = dt.getMonth() - df.getMonth();
  if (partialMonths < 0) {
    allYears--;
    partialMonths = partialMonths + 12;
  }
  var total = allYears;
  var totalMonths = partialMonths;
  console.log("total", total);

  useEffect(() => {
    setValue("experienceyy", total);
    setValue("experiencemm", totalMonths);
  }, [fromToDate, toDate]);

  //Print Applicable Table Send the Value
  let printApp;
  if (printApplicableWatch === false) {
    printApp = "No";
  } else if (printApplicableWatch === true) {
    printApp = "Yes";
  }

  //  DOB ==1st case [[API Calculate Age Based on DOB]]
  // const getAgeDOB = (e) => {
  //   let dobValue = e;
  //   //console.log("DOB VALUE", dobValue);
  //   let dobGivenYear = dobValue.getFullYear();
  //   let dobGivenMonth = String(dobValue.getMonth() + 1).padStart(2, "0");
  //   let dobGivenDay = String(dobValue.getDate()).padStart(2, "0");
  //   let fullDOB = [dobGivenYear, dobGivenMonth, dobGivenDay].join("-");

  //   getBirthDateAPI(0, fullDOB).then((response) => {
  //     // setValue("age", response.data.result.years, { shouldValidate: true });
  //     setValue("yy", response.data.result.years);
  //     setValue("mm", response.data.result.months);
  //     setValue("dd", response.data.result.days);
  //     // setValue("dob", dobGivenYear, dobGivenMonth, day);
  //   });
  // };

  const getAgeDOB = (e) => {
    // ✅ STRICT CHECK
    if (!e || !(e instanceof Date) || isNaN(e.getTime())) {
      console.log("Invalid date:", e);
      return;
    }

    // ✅ SAFE FORMAT (NO ISO BUG)
    const year = e.getFullYear();
    const month = String(e.getMonth() + 1).padStart(2, "0");
    const day = String(e.getDate()).padStart(2, "0");

    const fullDOB = `${year}-${month}-${day}`;

    console.log("DOB SENT:", fullDOB);


    if (fullDOB.includes("NaN") || fullDOB.startsWith("0")) {
      console.log("Blocked invalid DOB:", fullDOB);
      return;
    }

    getBirthDateAPI(0, fullDOB)
      .then((response) => {
        const result = response?.data?.result;

        if (!result) {
          console.error("API returned null:", response);
          return;
        }

        setValue("yy", result.ageYear ?? 0);
        setValue("mm", result.ageMonth ?? 0);
        setValue("dd", result.ageDays ?? 0);

      })
      .catch((err) => {
        console.error("API ERROR:", err);
      });
  };

  //OnSubmit Function Qualification
  const handleEduOnSubmit = () => {
    if (degreeWatch === null && universityWatch === "") {
      setError("degree", { type: "custom", message: "custom message" });

      setError("university", { type: "custom", message: "custom message" });
    } else if (degreeWatch === null) {
      setError("degree", { type: "custom", message: "custom message" });
    } else if (universityWatch === "") {
      setError("university", { type: "custom", message: "custom message" });
    }
    if (degreeWatch !== null && universityWatch !== "") {
      let eduarr = [...eduData];
      let obj = {
        qualificationId: degreeWatch.id,
        qualificationDec: degreeWatch.label,
        yearOfPassing:
          Number(yearofPassingWatch) !== "" ? Number(yearofPassingWatch) : 0,
        university: universityWatch,
        classOrMarks: classMarksWatch,
        printApplicable: printApplicableWatch,
        printAppValue: printApp,
        educationId: 0,
      };

      const eduAlreadyExists = eduData.some(
        (item) =>
          item["yearOfPassing"] === obj["yearOfPassing"] &&
          item["university"] === obj["university"] &&
          item["qualificationDec"] === obj["qualificationDec"]
      );

      if (!eduAlreadyExists) {
        eduarr.push(obj);
        handleExpReset();
      } else if (eduAlreadyExists) {
        warningAlert("Record Already Exist");
      }

      setEduData(eduarr);
    }
  };

  let fromDateWatch = watch("fromDate");
  let toDateWatch = watch("toDate");
  //Reset Function Qualification
  const handleReset = () => {
    setValue("degree", null);
    setValue("yearofPassing", "");
    setValue("university", "");
    setValue("classMarks", "");
    setValue("printApplicable", false);
  };

  const handleExperienceonSubmit = () => {
    if (postHeldWatch === "" && companyWatch === "") {
      setError("postHeld", { type: "custom", message: "custom message" });
      setError("company", { type: "custom", message: "custom message" });
    } else if (postHeldWatch === "") {
      setError("postHeld", { type: "custom", message: "custom message" });
    } else if (companyWatch === "") {
      setError("company", { type: "custom", message: "custom message" });
    }

    let Exparr = [...experienceData];
    if (postHeldWatch !== "" && companyWatch !== "") {

      let fromDateFormatted = "";
      let toDateFormatted = "";

      if (
        fromDateWatch instanceof Date &&
        !isNaN(fromDateWatch.getTime())
      ) {
        fromDateFormatted =
          fromDateWatch.toISOString().split("T")[0] + "T00:00:00.000";
      }

      if (
        toDateWatch instanceof Date &&
        !isNaN(toDateWatch.getTime())
      ) {
        toDateFormatted =
          toDateWatch.toISOString().split("T")[0] + "T00:00:00.000";
      }
      let obj = {
        fromDate: fromDateFormatted,
        toDate: toDateFormatted,
        // fromDate:
        //   fromDateWatch
        //     .toLocaleDateString()
        //     .replaceAll("/", "-")
        //     .split("-")
        //     .reverse()
        //     .join("-") +
        //   "T" +
        //   "00:00:00.000",
        // // dateFrom: format(fromToDate, "yyyy-MM-dd"),
        // toDate:
        //   toDateWatch
        //     .toLocaleDateString()
        //     .replaceAll("/", "-")
        //     .split("-")
        //     .reverse()
        //     .join("-") +
        //   "T" +
        //   "00:00:00.000",

        // dateTo: format(toDate, "yyyy-MM-dd"),
        expYear:
          Number(experienceyyWatch) !== "" ? Number(experienceyyWatch) : 0,
        expMonth:
          Number(experiencemmWatch) !== "" ? Number(experiencemmWatch) : 0,
        lastDrawnSalary:
          Number(lastSalaryDrawneWatch) !== ""
            ? Number(lastSalaryDrawneWatch)
            : 0,
        postHeld: postHeldWatch,
        company: companyWatch,
        reasonForLeaving: reasonForleavingWatch,
        experienceId: 0,
      };

      const expAlreadyExists = experienceData.some(
        (item) =>
          item["fromDate"] === obj["fromDate"] &&
          item["toDate"] === obj["toDate"]
      );

      console.log("dependentAlreadyExists", expAlreadyExists);

      if (!expAlreadyExists) {
        Exparr.push(obj);
        handleExpReset();
      } else if (expAlreadyExists) {
        warningAlert("Record Already Exist");
      }

      setExperienceData(Exparr);
    }
  };
  const handleExpReset = () => {
    setValue("experienceyy", "");
    setValue("experiencemm", "");
    setValue("lastSalaryDrawn", "");
    setValue("postHeld", "");
    setValue("company", "");
    setValue("reasonForleaving", "");
  };
  // let birthMoth = parseInt(new Date()) - parseInt(dateofBirth);
  let birthMoth = dateofBirth ? new Date() - new Date(dateofBirth) : 0;
  console.log("birthMothbirthMothbirthMoth", birthMoth);

  let MedicalVal;
  if (MedicalWatch === "yes") {
    MedicalVal = true;
  } else if (MedicalWatch === "no") {
    MedicalVal = false;
  }

  //findById API Function
  const doctorDetail = (doctorId) => {
    getDoctorDetail(doctorId)
      .then((response) => response.data)
      .then((res) => {
        setDoctorData(res.result);
      });
  };

  useEffect(() => {
    if (isDoctorWatch === true && doctorData && Object.keys(doctorData).length > 0) {
      let prefixDocObj = {
        id: doctorData["Prefix ID"],
        label: doctorData["Prefix"],
        value: doctorData["Prefix ID"],
      };
      let religionObj = {
        id: doctorData["Religion ID"],
        label: doctorData["Religion"],
        value: doctorData["Religion ID"],
      };
      let motherTonghObj = {
        id: doctorData["Mother Tongue ID"],
        label: doctorData["Mother Tongue"],
        value: doctorData["Mother Tongue ID"],
      };
      let bloodGroupObj = {
        id: doctorData["Blood Group ID"],
        label: doctorData["Blood Group"],
        value: doctorData["Blood Group ID"],
      };
      let maritalStatusObj = {
        id: doctorData["Marital Status ID"],
        label: doctorData["Marital Status "],
        value: doctorData["Marital Status ID"],
      };
      let designationObj = {
        id: doctorData["Designation ID"],
        label: doctorData["Designation"],
        value: doctorData["Designation ID"],
      };
      let EmployeeTypeObj = {
        id: doctorData["Designation ID"],
        label: doctorData["Designation"],
        value: doctorData["Designation ID"],
      };
      let localCountryObj = {
        id: doctorData["Local Country ID"],
        label: doctorData["Local Country"],
        value: doctorData["Local Country ID"],
      };
      let localStateObj = {
        id: doctorData["Local State ID"],
        label: doctorData["Local State"],
        value: doctorData["Local State ID"],
      };

      let localDistrictObj = {
        id: doctorData["Local District ID"],
        label: doctorData["Local District"],
        value: doctorData["Local District ID"],
      };

      let localCityObj = {
        id: doctorData["Local City ID"],
        label: doctorData["Local City"],
        value: doctorData["Local City ID"],
      };

      let localAreaObj = {
        id: doctorData["Local Area ID"],
        label: doctorData["Local Area"],
        value: doctorData["Local Area ID"],
      };

      let countryObj = {
        id: doctorData["Permanent Country ID"],
        label: doctorData["Permanent Country"],
        value: doctorData["Permanent Country ID"],
      };
      let stateObj = {
        id: doctorData["Permanent State ID"],
        label: doctorData["Permanent State"],
        value: doctorData["Permanent State ID"],
      };
      let districtObj = {
        id: doctorData["Permanent District ID"],
        label: doctorData["Permanent District"],
        value: doctorData["Permanent District ID"],
      };
      let cityObj = {
        id: doctorData["Permanent City ID"],
        label: doctorData["Permanent City"],
        value: doctorData["Permanent City ID"],
      };
      let areaObj = {
        id: doctorData["Permanent Area ID"],
        label: doctorData["Permanent Area"],
        value: doctorData["Permanent Area ID"],
      };
      setValue("prefix", prefixDocObj);
      setValue("firstName", doctorData["First Name"]);
      setValue("middleName", doctorData["Middle Name"]);
      setValue("lastName", doctorData["Last Name"]);
      setValue("religion", religionObj);
      setValue("motherTongh", motherTonghObj);
      setValue("bloodGroup", bloodGroupObj);
      setValue("maritalStatus", maritalStatusObj);
      setValue("designation", designationObj);
      setValue("EmployeeType", EmployeeTypeObj);
      setValue("panNo", doctorData?.["PAN No"] ?? "");
      setValue("telephoneNo", doctorData?.["TelNo"] ?? "");
      setValue("emailID", doctorData?.["Email ID"] ?? "");
      setValue("localaddress", doctorData?.["Local Address"] ?? "");
      setValue("localPinCode", doctorData?.["Local PIN"] ?? "");
      setValue("address", doctorData?.["Permanent Address"] ?? "");
      setValue("localCountry", localCountryObj);
      setValue("localState", localStateObj);
      setValue("localDistrict", localDistrictObj);
      setValue("localCity", localCityObj);
      setValue("localArea", localAreaObj);
      // setValue("localPinCode", doctorData["Local PIN"]);
      // setValue("address", doctorData["Permanent Address"]);
      setValue("country", countryObj);
      setValue("state", stateObj);
      setValue("district", districtObj);
      setValue("city", cityObj);
      setValue("area", areaObj);
      // "1971-01-29T18:30:00.000+00:00"
      // let DateString = doctorData["Birth Date"]
      //   .toString()
      //   .replaceAll("T18:30:00.000+00:00", "")
      //   .replaceAll("-", "/");
      // let dateofBirth = new Date(DateString);
      // console.log("the dateworking on :", DateString); //.toString().replaceAll("+00:00", "")
      // setValue("dateofBirth", dateofBirth);
      // // setDateOfBirth(dateofBirth);
      // let dateOfAnniversary = new Date(
      //   doctorData["Date of Anniversary"]
      //     .toString()
      //     .replaceAll("T18:30:00.000+00:00", "")
      //     .replaceAll("-", "/")
      // );
      // setValue("dateOfAnniversary", dateOfAnniversary);
      // // setDateOfAnniversary(dateOfAnniversary);
      // let DateOfJoining = new Date(
      //   doctorData["Date Of Joining"]
      //     .toString()
      //     .replaceAll("T18:30:00.000+00:00", "")
      //     .replaceAll("-", "/")
      // );
      // setValue("dateOfJoining", DateOfJoining);
      // // setDateOfJoining(DateOfJoining);

      // Birth Date
      // 🔥 ADD THIS FUNCTION ABOVE useEffect (top of file once)
      const parseDateSafe = (dateStr) => {
        if (!dateStr) return null;

        // ignore backend dummy date
        if (dateStr.startsWith("1900-01-01")) return null;

        const [datePart] = dateStr.split("T");
        const [year, month, day] = datePart.split("-");

        const parsed = new Date(year, month - 1, day);

        return isNaN(parsed.getTime()) ? null : parsed;
      };

    }
  }, [doctorData]);

  let dateOfBirthsWatch = watch("dateOfBirths")
  const handleDependentSubmit = () => {
    if (dependentFirstNameWatch === "" && dependentLastNameWatch === "") {
      setError("dependentFirstName", {
        type: "custom",
        message: "custom message",
      });

      setError("dependentLastName", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentFirstNameWatch === "") {
      setError("dependentFirstName", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentLastNameWatch === "") {
      setError("dependentLastName", {
        type: "custom",
        message: "custom message",
      });
    }

    // if (dependentFirstNameWatch !== "" && dependentLastNameWatch !== "") {
    //   let dependentArr = [...dependentData];
    //   let obj = {
    //     firstName: dependentFirstNameWatch,
    //     middleName: dependentMiddleNameWatch,
    //     lastName: dependentLastNameWatch,
    //     // birthDate:
    //     //   dateOfBirthsWatch
    //     //     .toLocaleDateString()
    //     //     .replaceAll("/", "-")
    //     //     .split("-")
    //     //     .reverse()
    //     //     .join("-") +
    //     //   "T" +
    //     //   "00:00:00.000",
    //     birthDate: dateOfBirthsWatch
    //       ? dateOfBirthsWatch
    //         .toLocaleDateString()
    //         .replaceAll("/", "-")
    //         .split("-")
    //         .reverse()
    //         .join("-") + "T00:00:00.000"
    //       : "",
    //     // birthDateDep: dateOfBirthsWatch.toLocaleDateString(),
    //     birthDateDep: dateOfBirthsWatch?.toLocaleDateString() || "",
    //     age: Number(dependentAgeWatch) !== "" ? Number(dependentAgeWatch) : 0,
    //     relationId:
    //       dependentRelationWatch !== null ? dependentRelationWatch?.id : 0,
    //     relationDec: dependentRelationWatch?.label || "",
    //     occupationId:
    //       dependentOccupationWatch !== null ? dependentOccupationWatch.id : 0,
    //     occupationDecs: dependentOccupationWatch?.label || "",
    //     sexId: dependentGenderWatch !== null ? dependentGenderWatch?.id : 0,
    //     sexDec: dependentGenderWatch?.label || "",
    //     applicability: MedicalVal,
    //     benefitPercentage: 0,
    //     dependentId: 0,
    //     patientId: 0,
    //     empCode: 0,
    //   };

    //   const dependentAlreadyExists = dependentData.some(
    //     (item) =>
    //       item["firstName"] === obj["firstName"] &&
    //       item["lastName"] === obj["lastName"] &&
    //       item["relationDec"] === obj["relationDec"]
    //   );

    //   console.log("dependentAlreadyExists", dependentAlreadyExists);

    //   if (!dependentAlreadyExists) {
    //     dependentArr.push(obj);

    //     handleDepReset();
    //   } else if (dependentAlreadyExists) {
    //     warningAlert("Record Already Exist");
    //   }

    //   setDependentData(dependentArr);
    // }

    let birthDateFormatted = "";

    if (
      dateOfBirthsWatch &&
      dateOfBirthsWatch instanceof Date &&
      !isNaN(dateOfBirthsWatch.getTime())
    ) {
      birthDateFormatted =
        dateOfBirthsWatch.toISOString().split("T")[0] + "T00:00:00.000";
    }

    let obj = {
      firstName: dependentFirstNameWatch,
      middleName: dependentMiddleNameWatch,
      lastName: dependentLastNameWatch,

      birthDate: birthDateFormatted,

      birthDateDep:
        dateOfBirthsWatch &&
          dateOfBirthsWatch instanceof Date &&
          !isNaN(dateOfBirthsWatch.getTime())
          ? dateOfBirthsWatch.toLocaleDateString()
          : "",
    };
  };

  const handleReference = () => {
    if (
      EmployeeNameWatch === "" &&
      CompanyNameWatch === "" &&
      PositionHeldWatch === "" &&
      AddressWatch === ""
    ) {
      setError("employeeName", { type: "custom", message: "custom message" });
      setError("companyName", { type: "custom", message: "custom message" });
      setError("positionHeld", {
        type: "custom",
        message: "custom message",
      });
      setError("referenceAddress", {
        type: "custom",
        message: "custom message",
      });
    } else if (EmployeeNameWatch === "") {
      setError("employeeName", { type: "custom", message: "custom message" });
    } else if (CompanyNameWatch === "") {
      setError("companyName", { type: "custom", message: "custom message" });
    } else if (PositionHeldWatch === "") {
      setError("positionHeld", {
        type: "custom",
        message: "custom message",
      });
    } else if (AddressWatch === "") {
      setError("referenceAddress", {
        type: "custom",
        message: "custom message",
      });
    }
    if (
      EmployeeNameWatch !== "" &&
      CompanyNameWatch !== "" &&
      PositionHeldWatch !== "" &&
      AddressWatch !== ""
    ) {
      let obj = {
        address: AddressWatch,
        positionHold: PositionHeldWatch,
        employeeName: EmployeeNameWatch,
        company: CompanyNameWatch,
        referenceId: 0,
      };
      let arr = [];
      arr.push(obj);
      setReferenceData(arr);
    }
  };
  const handleResetReferanance = () => {
    setValue("employeeName", "");
    setValue("companyName", "");
    setValue("positionHeld", "");
    setValue("referenceAddress", "");
  };

  const handleDepReset = () => {
    setValue("dependentFirstName", "");
    setValue("dependentMiddleName", "");
    setValue("dependentLastName", "");
    setValue("dependentGender", null);
    setValue("dependentAge", "");
    setValue("dependentRelation", null);
    setValue("dependentOccupation", null);
  };

  function bloodGroupApi() {
    bloodGroupDropdown().then((response) => {
      setbloodGroupOption(response.data.result);
    });
  }
  function maritalStatusApi() {
    maritalStatusDropdown().then((response) => {
      setMaritalStatusOption(response.data.result);
    });
  }

  function prefixDropdownApi() {
    prefixDropdown().then((response) => {
      setPrefixOption(response.data.result);
    });
  }

  function religionDropdownApi() {
    religionDropdown().then((response) => {
      setReligionOption(response.data.result);
    });
  }
  function motherTonghDropdownApi() {
    motherTonghDropdown().then((response) => {
      setMotherTonghOption(response.data.result);
    });
  }

  function designationDropdownApi() {
    designationDropdown().then((response) => {
      setDesignationOptions(response.data.result);
    });
  }
  function classificationDropdownApi() {
    EmpclassificationDropdown().then((response) => {
      setClassificationOption(response.data.result);
    });
  }

  function categoryDropdownApi() {
    EmployeeCategoryDropDown().then((response) => {
      setCategoryOption(response.data.result);
    });
  }

  function degreeDropdownApi() {
    degreeDropdown().then((response) => {
      setDegreeOption(response.data.result);
    });
  }
  function bankDropdownApi() {
    bankDropdown().then((response) => {
      setBankOption(response.data.result);
    });
  }
  function countryDropDownApi() {
    countryDropDown().then((response) => {
      setCountryOption(response.data.result);
    });
  }
  function stateDropdownApi() {
    if (typeof countryId === "number") {
      stateDropDown(countryId).then((response) => {
        setStateOption(response.data.result);
      });
    }
  }
  function districtDropDownApi(stateId) {
    if (typeof stateId === "number") {
      districtDropDown(stateId).then((response) => {
        setDistrictOption(response.data.result);
      });
    }
  }

  function cityDropDownApi(districtId) {
    if (typeof districtId === "number") {
      cityDropDown(districtId).then((response) => {
        setCityOption(response.data.result);
      });
    }
  }

  function areaApi(cityId) {
    if (typeof cityId === "number") {
      areaDropDown(cityId).then((response) => {
        setAreaOption(response.data.result);
      });
    }
  }

  //Unit Dropdown API
  function unitDropDownApi() {
    unitDropDown().then((response) => {
      setUnitOption(response.data.result);
    });
  }

  function genderDropDownApi() {
    genderDropDown().then((response) => {
      setGenderOption(response.data.result);
    });
  }

  function relationDropDownApi() {
    relationDropdown().then((response) => {
      setRelationOption(response.data.result);
    });
  }

  function occupationDropDownApi() {
    occupationDropdown().then((response) => {
      setOccupationOption(response.data.result);
    });
  }

  // function departmentDropDownApi() {
  //   departmentDropdownList().then((response) => {
  //     setDepartMentOption(response.data.result);
  //   });
  // }

  function empCategoryDropdownApi(classificationId) {
    if (typeof classificationId === "number") {
      EmpcategoryDropdown(classificationId).then((response) => {
        setCategoryOption(response.data.result);
      });
    }
  }

  //Autosearch API Function
  const handleChanges = (autoSearchString) => {
    if (autoSearchString !== "") {
      doctorSearchDropDown(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          setDoctorOption(res.result);
        });
    }
  };

  const handleChangesDeparment = (autoSearchString) => {
    if (autoSearchString !== "") {
      departmentDropdownList(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          setDepartMentOption(res.result);
        });
    }
  };

  const handleChangesreportingTo = (autoSearchString) => {
    if (autoSearchString !== "") {
      EmployeeDropDown(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          setreportingToOption(res.result);
        });
    }
  };

  let account;
  if (accountTypeWatch === "saving") {
    account = "S";
  } else if (accountTypeWatch === "current") {
    account = "C";
  }

  let clinic;
  if (StaffWatch === "staff") {
    clinic = "0";
  } else if (StaffWatch === "polyclinic") {
    clinic = "1";
  } else if (StaffWatch === "nursing") {
    clinic = "2";
  }

  // setUnit(UnitWatch)

  let unitArr = UnitWatch?.map((row) => row?.id);

  let ClassificationArr = unitClassificationWatch?.map((row) => row.id);
  let DepartmentArr = unitDepartmentWatch?.map((row) => row.id);
  const handleCheckSubmit = (e) => {
    if (e.target.value === true) {
      setValue("localaddress", addressWatch);
      setValue("localCountry", countryWatch);
      setValue("localState", stateWatch);
      setValue("localDistrict", districtWatch);
      setValue("localtaluka", talukaWatch);
      setValue("localCity", cityWatch);
      setValue("localArea", AreaWatch);
      setValue("localPinCode", pinCodeWatch);
    } else if (e.target.value === false) {
      setValue("localaddress", "");
      setValue("localCountry", null);
      setValue("localState", null);
      setValue("localDistrict", null);
      setValue("localtaluka", null);
      setValue("localCity", null);
      setValue("localArea", null);
      setValue("localPinCode", "");
    }
  };

  useEffect(() => {
    countryDropDownApi();
    stateDropdownApi();
    districtDropDownApi(stateId);
    cityDropDownApi(districtId);
    areaApi(cityId);
  }, [countryId, stateId, districtId, cityId]);

  useEffect(() => {
    bloodGroupApi();
    maritalStatusApi();
    unitDropDownApi();
    prefixDropdownApi();
    religionDropdownApi();
    motherTonghDropdownApi();
    designationDropdownApi();
    classificationDropdownApi();
    categoryDropdownApi();
    degreeDropdownApi();
    bankDropdownApi();
    genderDropDownApi();
    relationDropDownApi();
    occupationDropDownApi();
    // departmentDropDownApi();
    empCategoryDropdownApi(classificationId);

    setValue("benefitType", benefitTypes?.[0]);
  }, [classificationId]);

  const deleteRecord = (index, header) => {
    let numTempleData = [];
    if (index !== null) {
      if (header === "eduData") {
        numTempleData = [...eduData];
        numTempleData.splice(index, 1);
        setEduData(numTempleData);
      } else if (header === "expData") {
        numTempleData = [...experienceData];
        numTempleData.splice(index, 1);
        setExperienceData(numTempleData);
      } else if (header === "depData") {
        numTempleData = [...dependentData];
        numTempleData.splice(index, 1);
        setDependentData(numTempleData);
      }
      else if (header === "referData") {
        numTempleData = [...referenceData];
        numTempleData.splice(index, 1);
        setReferenceData(numTempleData);
      }
    }
  };

  const RenderActions = (row, index) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <div
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, "eduData");
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };
  const RenderActionsExp = (row, index) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <div
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, "expData");
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };
  const RenderActionsDep = (row, index) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <div
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, "depData");
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };
  const RenderActionsRefenace = (row, index, header) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <div
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, (header = "referData"));
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };

  const formatDate = (date) => {
    return date instanceof Date && !isNaN(date.getTime())
      ? date.toISOString()
      : "";   // ✅ IMPORTANT CHANGE
  };

  let dateofBirthWatch = watch("dateofBirth");
  let renewalDateWatch = watch("renewalDate");
  let mahRenewalDateWatch = watch("mahRenewalDate");
  let dateOfAnniversaryWatch = watch("dateOfAnniversary");
  let dateOfJoiningWatch = watch("dateOfJoining");
  let fromDateEmpWatch = watch("fromDateEmp")
  let toDateEmpWatch = watch("toDateEmp")
  console.log("dateofBirthWatch", dateofBirthWatch);
  const onSubmitDataHandler = (data) => {
    let getIPDAmount;
    let getOPDAmount;
    let getPharmacyAmount;
    for (let obj of EmployeeBenefitsData) {
      if (obj.Group === "IPD") {
        getIPDAmount = obj.AmountPerYear;
      }
      if (obj.Group === "OPD") {
        getOPDAmount = obj.AmountPerYear;
      }
      if (obj.Group === "Pharmacy") {
        getPharmacyAmount = obj.AmountPerYear;
      }
    }

    if (props.edit === false) {

      // let saveObj = {
      //   id: 0,
      //   employeeId: 0,
      //   acType: account,
      //   accessCardNo: data.accessCardNo,
      //   addedBy: 154,
      //   ageDays: data.dd !== "" ? Number(data.dd) : 0,
      //   ageMonths: data.mm !== "" ? Number(data.mm) : 0,
      //   ageYears: data.yy !== "" ? Number(data.yy) : 0,
      //   applicableFrom: "2023-10-03T00:00:00.000Z",
      //   approvedBy: 0,
      //   bankAcNo: data.ACNo,
      //   bankBranchName: data.branchName,
      //   bankNameId: data.BankName !== null ? data.BankName?.id : Number(0),
      //   birthLocalDateTime:
      //     dateofBirthWatch
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",
      //   bloodGroupId:
      //     data.bloodGroup !== null ? data.bloodGroup?.id : Number(0),
      //   code: data.employeeCode,
      //   confirmationLocalDateTime: "2023-10-03T00:00:00.000Z",
      //   departmentId:
      //     data.department !== null ? data.department?.id : Number(0),
      //   designationId:
      //     data.designation !== null ? data.designation?.id : Number(0),
      //   doctorId: 0,
      //   emailId: data.emailID,
      //   empCategoryId: 0,
      //   empClassificationId:
      //     data.EmployeeType !== null ? data.EmployeeType?.id : Number(0),
      //   empPhoto: "string",
      //   empPhotoPath: "string",
      //   empSign: "string",
      //   employeePhotoDto: photoData,
      //   empSignatureDto: signData,
      //   empSinPath: "string",

      //   employeeBenefitsDto: {
      //     fromDate:
      //       fromDateEmpWatch
      //         .toLocaleDateString()
      //         .replaceAll("/", "-")
      //         .split("-")
      //         .reverse()
      //         .join("-") +
      //       "T" +
      //       "00:00:00.000Z",
      //     ipdAmount: Number(getIPDAmount),
      //     isCarriedForward: true,
      //     opdAmount: Number(getOPDAmount),
      //     pharmacyAmount: Number(getPharmacyAmount),
      //     toDate:
      //       toDateEmpWatch
      //         .toLocaleDateString()
      //         .replaceAll("/", "-")
      //         .split("-")
      //         .reverse()
      //         .join("-") +
      //       "T" +
      //       "00:00:00.000Z",
      //     year: 0,
      //   },

      //   employeeDependentDtoList: dependentData,
      //   employeeEducationDtoList: eduData,
      //   employeeExperienceDtoList: experienceData,
      //   employeeReferenceDtoList: referenceData,
      //   esiNo: data.eSINo,
      //   extension: data.extensionNo !== "" ? Number(data.extensionNo) : 0,
      //   // extension: 0,
      //   firstName: data.firstName,
      //   hasReportApprovalAuthority: true,
      //   isApproved: true,
      //   isOTApplicable: true,
      //   isShiftApplicable: true,
      //   isSupp: true,
      //   laddress: data.localaddress,
      //   lareaId: data.localArea !== null ? data.localArea?.id : Number(0),
      //   lastName: data.lastName,
      //   lastWorkingLocalDateTime:
      //     lastworking
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   lcityId: data.localCity !== null ? data.localCity?.id : Number(0),
      //   lcontactNo: "string",
      //   lcountryId:
      //     data.localCountry !== null ? data.localCountry?.id : Number(0),
      //   ldistrictId:
      //     data.localDistrict !== null ? data.localDistrict?.id : Number(0),
      //   localDateTimeOfAnniversary:
      //     dateOfAnniversaryWatch
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   localDateTimeOfJoining:
      //     dateOfJoiningWatch
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   lpin: data.localPinCode,
      //   lstateId: data.localState !== null ? data.localState?.id : Number(0),
      //   maritalStatusId:
      //     data.maritalStatus !== null ? data.maritalStatus?.id : Number(0),
      //   micrNo: "string",
      //   middleName: data.middleName,
      //   mobileNo: data.mobileNo,
      //   motherTongueId:
      //     data.motherTongh !== null ? data.motherTongh?.id : Number(0),
      //   paddress: data.address,
      //   panNo: data.panNo,
      //   pareaId: data.area !== null ? data.area?.id : Number(0),
      //   passportExpiryLocalDateTime:
      //     expiryDate
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   passportIssueLocalDateTime:
      //     issueDate
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   passportIssuePlace: data.issuePlace,
      //   passportNo: data.passportNo,
      //   patientId: 0,
      //   pcityId: data.city !== null ? data.city?.id : Number(0),
      //   pcontactNo: "string",
      //   pcountryId: data.country !== null ? data.country?.id : Number(0),
      //   pdistrictId: data.district !== null ? data.district?.id : Number(0),
      //   pfNo: data.PFNo,
      //   placeOfBirth: "string",
      //   ppin: data.pinCode,
      //   prefixId: data.prefix !== null ? data.prefix?.id : Number(0),
      //   pstateId: data.state !== null ? data.state?.id : Number(0),
      //   religionId: data.religion !== null ? data.religion?.id : Number(0),
      //   reportingTo:
      //     data.reportingTo !== null ? data.reportingTo?.id : Number(0),
      //   resignReason: data.resignReason,
      //   resignationDt:
      //     regDate
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",
      //   salaryMode: data.salaryMode?.id,
      //   sex: 0,
      //   status: data.status,
      //   subDepartmentId: 0,
      //   telNo: data.telephoneNo,
      //   transApp: true,
      //   unitIds: unitArr,
      //   upLocalDateTimedBy: 0,
      //   updatedBy: 154,
      //   wardId: 0,
      // };


      let saveObj = {
        id: null,
        active: data.status,

        prefixId: data.prefix?.id,

        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,

        // dateOfBirth: dateofBirthWatch
        //   ? new Date(dateofBirthWatch).toISOString().split("T")[0]
        //   : null,

        dateOfBirth:
          dateofBirthWatch instanceof Date && !isNaN(dateofBirthWatch.getTime())
            ? dateofBirthWatch.toISOString().split("T")[0]
            : null,

        ageYear: data.yy ? Number(data.yy) : 0,
        ageMonth: data.mm ? Number(data.mm) : 0,
        ageDays: data.dd ? Number(data.dd) : 0,

        religionId: data.religion?.id,
        motherTongueId: data.motherTongh?.id,
        bloodGroupId: data.bloodGroup?.id,
        maritalStatusId: data.maritalStatus?.id,

        panNo: data.panNo,
        telephoneNo: data.telephoneNo,
        mobileNo: data.mobileNo,
        emailId: data.emailID,

        designationId: data.designation?.id,
        departmentId: data.department?.id,
        empClassificationId: data.EmployeeType?.id,
        empCategoryId: data.employeeGrade?.id,

        // dateOfAnniversary: dateOfAnniversaryWatch
        //   ? new Date(dateOfAnniversaryWatch).toISOString()
        //   : null,

        dateOfAnniversary:
          dateOfAnniversaryWatch instanceof Date && !isNaN(dateOfAnniversaryWatch.getTime())
            ? dateOfAnniversaryWatch.toISOString()
            : null,

        // dateOfJoining: dateOfJoiningWatch
        //   ? new Date(dateOfJoiningWatch).toISOString()
        //   : null,

        dateOfJoining:
          dateOfJoiningWatch instanceof Date && !isNaN(dateOfJoiningWatch.getTime())
            ? dateOfJoiningWatch.toISOString()
            : null,

        bankNameId: data.BankName?.id,
        branchName: data.branchName,
        accountNo: data.ACNo,
        salaryMode: data.salaryMode?.id,
        accountType: account,

        photo: photoData?.empPhotoBase64,
        signature: signData?.empSignBase64,

        acessCardNo: data.accessCardNo,
        extension: data.extensionNo ? Number(data.extensionNo) : 0,
        reportingTo: data.reportingTo?.id,

        passportNo: data.passportNo,

        // passportIssuedate: issueDate
        //   ? new Date(issueDate).toISOString()
        //   : null,

        // passportExpirydate: expiryDate
        //   ? new Date(expiryDate).toISOString()
        //   : null,

        // lastWorkingDate: lastworking
        //   ? new Date(lastworking).toISOString()
        //   : null,

        // passportIssuedate:
        //   issueDate instanceof Date && !isNaN(issueDate.getTime())
        //     ? issueDate.toISOString()
        //     : null,

        // passportExpirydate:
        //   expiryDate instanceof Date && !isNaN(expiryDate.getTime())
        //     ? expiryDate.toISOString()
        //     : null,

        // lastWorkingDate:
        //   lastworking instanceof Date && !isNaN(lastworking.getTime())
        //     ? lastworking.toISOString()
        //     : null,


        passportIssuedate: formatDate(issueDate),
        passportExpirydate: formatDate(expiryDate),
        lastWorkingDate: formatDate(lastworking),
        resignationDt: formatDate(regDate),

        resignReason: data.resignReason,

        addedBy: 154,
        updatedBy: 154,

        date: new Date().toISOString(),
        time: new Date().toISOString(),

        pfnumber: data.PFNo,
        esinumber: data.eSINo,

        pcountryId: data.country?.id,
        pstateId: data.state?.id,
        lstateId: data.localState?.id,

        paddress: data.address,
        lareaId: data.localArea?.id,
        laddress: data.localaddress,

        ldistrictId: data.localDistrict?.id,
        lcountryId: data.localCountry?.id,

        pareaId: data.area?.id,
        pdistrictId: data.district?.id,

        ppinCode: data.pinCode,
        pcityId: data.city?.id,

        // resignationDt: regDate
        //   ? new Date(regDate).toISOString()
        //   : null,

        // resignationDt:
        //   regDate instanceof Date && !isNaN(regDate.getTime())
        //     ? regDate.toISOString()
        //     : null,

        lcityId: data.localCity?.id,
        lpinCode: data.localPinCode,

        passportIssuePlace: data.issuePlace
      };

      console.log("saveObj", saveObj);
      setFinalData(saveObj);
      setOpenPost(true);
    }


    if (props.edit === true) {
      let tempExpArr = [];
      for (let obj of [...experienceData]) {
        let tempExpObj = {
          // fromDate: obj.fromDate + "T" + "00:00:00.000",

          fromDate: obj.fromDate,
          toDate: obj.toDate,

          // dateTo: format(toDate, "yyyy-MM-dd"),
          expYear: Number(obj.expYear) !== "" ? Number(obj.expYear) : 0,
          expMonth: Number(obj.expMonth) !== "" ? Number(obj.expMonth) : 0,
          lastDrawnSalary:
            Number(obj.lastDrawnSalary) !== ""
              ? Number(obj.lastDrawnSalary)
              : 0,
          postHeld: obj.postHeld,
          company: obj.company,
          reasonForLeaving: obj.reasonForLeaving,
          experienceId: obj.experienceId ? obj.experienceId : 0,
        };
        tempExpArr.push(tempExpObj);
      }
      let tempEduArr = [];
      for (let obj of [...eduData]) {
        let tempObj = {
          qualificationId: obj.qualificationId,
          qualificationDec: obj.qualificationDec,
          yearOfPassing:
            Number(obj.yearPassing) !== "" ? Number(obj.yearPassing) : 0,
          university: obj.university,
          classOrMarks: obj.classOrMarks,
          printApplicable: obj.printApplicable === "Y" ? true : false,
          educationId: 0,
        };
        tempEduArr.push(tempObj);
      }

      // let updateObj = {
      //   id: 0,
      //   employeeId: props.editdatafetch["Employee ID"],
      //   acType: account,
      //   accessCardNo: data.accessCardNo,
      //   addedBy: 154,
      //   ageDays: data.dd !== "" ? Number(data.dd) : 0,
      //   ageMonths: data.mm !== "" ? Number(data.mm) : 0,
      //   ageYears: data.yy !== "" ? Number(data.yy) : 0,
      //   applicableFrom: "2023-10-03T00:00:00.000Z",
      //   approvedBy: 0,
      //   bankAcNo: data.ACNo,
      //   bankBranchName: data.branchName,
      //   bankNameId: data.BankName !== null ? data.BankName?.id : Number(0),
      //   birthLocalDateTime:
      //     dateofBirthWatch
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",
      //   bloodGroupId:
      //     data.bloodGroup !== null ? data.bloodGroup?.id : Number(0),
      //   code: data.employeeCode,
      //   confirmationLocalDateTime: "2023-10-03T00:00:00.000Z",
      //   departmentId:
      //     data.department !== null ? data.department?.id : Number(0),
      //   designationId:
      //     data.designation !== null ? data.designation?.id : Number(0),
      //   doctorId: 0,
      //   emailId: data.emailID,
      //   empCategoryId: 0,
      //   empClassificationId:
      //     data.EmployeeType !== null ? data.EmployeeType?.id : Number(0),
      //   empPhoto: "string",
      //   empPhotoPath: "string",
      //   empSign: "string",
      //   employeePhotoDto: photoData,
      //   empSignatureDto: signData,
      //   empSinPath: "string",

      //   employeeBenefitsDto: {
      //     fromDate:
      //       fromDateEmpWatch
      //         .toLocaleDateString()
      //         .replaceAll("/", "-")
      //         .split("-")
      //         .reverse()
      //         .join("-") +
      //       "T" +
      //       "00:00:00.000Z",
      //     ipdAmount: Number(getIPDAmount),
      //     isCarriedForward: true,
      //     opdAmount: Number(getOPDAmount),
      //     pharmacyAmount: Number(getPharmacyAmount),
      //     toDate:
      //       toDateEmpWatch
      //         .toLocaleDateString()
      //         .replaceAll("/", "-")
      //         .split("-")
      //         .reverse()
      //         .join("-") +
      //       "T" +
      //       "00:00:00.000Z",
      //     year: 0,
      //   },

      //   employeeDependentDtoList: dependentData,
      //   employeeEducationDtoList: tempEduArr,
      //   employeeExperienceDtoList: tempExpArr,
      //   employeeReferenceDtoList: referenceData,
      //   esiNo: data.eSINo,
      //   extension: data.extensionNo !== "" ? Number(data.extensionNo) : 0,
      //   // extension: 0,
      //   firstName: data.firstName,
      //   hasReportApprovalAuthority: true,
      //   isApproved: true,
      //   isOTApplicable: true,
      //   isShiftApplicable: true,
      //   isSupp: true,
      //   laddress: data.localaddress,
      //   lareaId: data.localArea !== null ? data.localArea?.id : Number(0),
      //   lastName: data.lastName,
      //   lastWorkingLocalDateTime:
      //     lastworking
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   lcityId: data.localCity !== null ? data.localCity?.id : Number(0),
      //   lcontactNo: "string",
      //   lcountryId:
      //     data.localCountry !== null ? data.localCountry?.id : Number(0),
      //   ldistrictId:
      //     data.localDistrict !== null ? data.localDistrict?.id : Number(0),
      //   localDateTimeOfAnniversary:
      //     dateOfAnniversaryWatch
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   localDateTimeOfJoining:
      //     dateOfJoiningWatch
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   lpin: data.localPinCode,
      //   lstateId: data.localState !== null ? data.localState?.id : Number(0),
      //   maritalStatusId:
      //     data.maritalStatus !== null ? data.maritalStatus?.id : Number(0),
      //   micrNo: "string",
      //   middleName: data.middleName,
      //   mobileNo: data.mobileNo,
      //   motherTongueId:
      //     data.motherTongh !== null ? data.motherTongh?.id : Number(0),
      //   paddress: data.address,
      //   panNo: data.panNo,
      //   pareaId: data.area !== null ? data.area?.id : Number(0),
      //   passportExpiryLocalDateTime:
      //     expiryDate
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   passportIssueLocalDateTime:
      //     issueDate
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",

      //   passportIssuePlace: data.issuePlace,
      //   passportNo: data.passportNo,
      //   patientId: 0,
      //   pcityId: data.city !== null ? data.city?.id : Number(0),
      //   pcontactNo: "string",
      //   pcountryId: data.country !== null ? data.country?.id : Number(0),
      //   pdistrictId: data.district !== null ? data.district?.id : Number(0),
      //   pfNo: data.PFNo,
      //   placeOfBirth: "string",
      //   ppin: data.pinCode,
      //   prefixId: data.prefix !== null ? data.prefix?.id : Number(0),
      //   pstateId: data.state !== null ? data.state?.id : Number(0),
      //   religionId: data.religion !== null ? data.religion?.id : Number(0),
      //   reportingTo:
      //     data.reportingTo !== null ? data.reportingTo?.id : Number(0),
      //   resignReason: data.resignReason,
      //   resignationDt:
      //     regDate
      //       .toLocaleDateString()
      //       .replaceAll("/", "-")
      //       .split("-")
      //       .reverse()
      //       .join("-") +
      //     "T" +
      //     "00:00:00.000Z",
      //   salaryMode: data.salaryMode?.id,
      //   sex: 0,
      //   status: data.status,
      //   subDepartmentId: 0,
      //   telNo: data.telephoneNo,
      //   transApp: true,
      //   unitIds: unitArr,
      //   upLocalDateTimedBy: 0,
      //   updatedBy: 154,
      //   wardId: 0,
      // };

      let updateObj = {
        id: props.editdatafetch?.id,
        active: data.status,

        prefixId: data.prefix?.id,

        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,

        // dateOfBirth: dateofBirthWatch
        //   ? new Date(dateofBirthWatch).toISOString().split("T")[0]
        //   : null,

        dateOfBirth:
          dateofBirthWatch instanceof Date && !isNaN(dateofBirthWatch.getTime())
            ? dateofBirthWatch.toISOString().split("T")[0]
            : null,

        ageYear: data.yy ? Number(data.yy) : 0,
        ageMonth: data.mm ? Number(data.mm) : 0,
        ageDays: data.dd ? Number(data.dd) : 0,

        religionId: data.religion?.id,
        motherTongueId: data.motherTongh?.id,
        bloodGroupId: data.bloodGroup?.id,
        maritalStatusId: data.maritalStatus?.id,

        panNo: data.panNo,
        telephoneNo: data.telephoneNo,
        mobileNo: data.mobileNo,
        emailId: data.emailID,

        designationId: data.designation?.id,
        departmentId: data.department?.id,
        empClassificationId: data.EmployeeType?.id,
        empCategoryId: data.employeeGrade?.id,

        // dateOfAnniversary: dateOfAnniversaryWatch
        //   ? new Date(dateOfAnniversaryWatch).toISOString()
        //   : null,

        dateOfAnniversary:
          dateOfAnniversaryWatch instanceof Date && !isNaN(dateOfAnniversaryWatch.getTime())
            ? dateOfAnniversaryWatch.toISOString()
            : null,

        // dateOfJoining: dateOfJoiningWatch
        //   ? new Date(dateOfJoiningWatch).toISOString()
        //   : null,

        dateOfJoining:
          dateOfJoiningWatch instanceof Date && !isNaN(dateOfJoiningWatch.getTime())
            ? dateOfJoiningWatch.toISOString()
            : null,

        bankNameId: data.BankName?.id,
        branchName: data.branchName,
        accountNo: data.ACNo,
        salaryMode: data.salaryMode?.id,
        accountType: account,

        photo: photoData?.empPhotoBase64,
        signature: signData?.empSignBase64,

        acessCardNo: data.accessCardNo,
        extension: data.extensionNo ? Number(data.extensionNo) : 0,
        reportingTo: data.reportingTo?.id,

        passportNo: data.passportNo,

        // passportIssuedate: issueDate
        //   ? new Date(issueDate).toISOString()
        //   : null,

        // passportExpirydate: expiryDate
        //   ? new Date(expiryDate).toISOString()
        //   : null,

        // lastWorkingDate: lastworking
        //   ? new Date(lastworking).toISOString()
        //   : null,

        // passportIssuedate:
        //   issueDate instanceof Date && !isNaN(issueDate.getTime())
        //     ? issueDate.toISOString()
        //     : null,

        // passportExpirydate:
        //   expiryDate instanceof Date && !isNaN(expiryDate.getTime())
        //     ? expiryDate.toISOString()
        //     : null,

        // lastWorkingDate:
        //   lastworking instanceof Date && !isNaN(lastworking.getTime())
        //     ? lastworking.toISOString()
        //     : null,


        passportIssuedate: formatDate(issueDate),
        passportExpirydate: formatDate(expiryDate),
        lastWorkingDate: formatDate(lastworking),
        resignationDt: formatDate(regDate),

        resignReason: data.resignReason,

        addedBy: 154,
        updatedBy: 154,

        date: new Date().toISOString(),
        time: new Date().toISOString(),

        pfnumber: data.PFNo,
        esinumber: data.eSINo,

        pcountryId: data.country?.id,
        pstateId: data.state?.id,
        lstateId: data.localState?.id,

        paddress: data.address,
        lareaId: data.localArea?.id,
        laddress: data.localaddress,

        ldistrictId: data.localDistrict?.id,
        lcountryId: data.localCountry?.id,

        pareaId: data.area?.id,
        pdistrictId: data.district?.id,

        ppinCode: data.pinCode,
        pcityId: data.city?.id,

        // resignationDt: regDate
        //   ? new Date(regDate).toISOString()
        //   : null,

        // resignationDt:
        //   regDate instanceof Date && !isNaN(regDate.getTime())
        //     ? regDate.toISOString()
        //     : null,

        lcityId: data.localCity?.id,
        lpinCode: data.localPinCode,

        passportIssuePlace: data.issuePlace
      };

      console.log("updateObj", updateObj);
      setOpenPut(true);
      setFinalData(updateObj);
    }
  };

  //Post / Add API Function
  function addRecord() {
    postEmployee(finalData)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        props.setOpen(false);
        props.setEdit(false);
        setOpenPost(false);
        props.populateTable();
        setOpenPut(false);
      })
      .catch((error) => {
        errorAlert(error.message);
      });
    // reset(defaultValues);
    setFile(null);
    setUploadFile(null);
    setPhotoData(null);
    setSignData(null);
    setIssueDate(null);
    setExpiryDate(null);
    setLastWorking(null);
    setRegDate(null);
  }

  // React.useEffect(() => {
  //   if (props.edit === true) {
  //     console.log("props.editdatafetch", props.editdatafetch);

  //     let Status;
  //     if (props.editdatafetch["Status"] === "Active") {
  //       Status = true;
  //     } else if (props.editdatafetch["Status"] === "InActive") {
  //       Status = false;
  //     }
  //     let unitDoc = props.editdatafetch.empUnits;
  //     let unitArr = [];
  //     for (let i = 0; i < unitDoc?.length; i++) {
  //       let unitObj = {
  //         id: unitDoc[i]["UnitId"],
  //         value: unitDoc[i]["UnitId"],
  //         label: unitDoc[i]["Unit Name"],
  //       };
  //       unitArr.push(unitObj);
  //       setValue("unit", unitArr);
  //     }
  //     let prefixObj = {
  //       id: props.editdatafetch["Prefix ID"],
  //       value: props.editdatafetch["Prefix ID"],
  //       label: props.editdatafetch["Prefix"],
  //     };

  //     let religionObj = {
  //       id: props.editdatafetch["Religion ID"],
  //       value: props.editdatafetch["Religion ID"],
  //       label: props.editdatafetch["Religion"],
  //     };

  //     let motherTonghObj = {
  //       id: props.editdatafetch["Mother Tongue ID"],
  //       value: props.editdatafetch["Mother Tongue ID"],
  //       label: props.editdatafetch["Mother Tongue"],
  //     };
  //     let bloodGroupObj = {
  //       id: props.editdatafetch["Blood Group ID"],
  //       value: props.editdatafetch["Blood Group ID"],
  //       label: props.editdatafetch["Blood Group"],
  //     };
  //     let maritalStatusObj = {
  //       id: props.editdatafetch["Marital Status ID"],
  //       value: props.editdatafetch["Marital Status ID"],
  //       label: props.editdatafetch["Marital Status"],
  //     };
  //     let designationObj = {
  //       id: props.editdatafetch["Designation ID"],
  //       value: props.editdatafetch["Designation ID"],
  //       label: props.editdatafetch["Designation"],
  //     };
  //     let EmployeeTypeObj = {
  //       id: props.editdatafetch["Employee Classification ID"],
  //       value: props.editdatafetch["Employee Classification ID"],
  //       label: props.editdatafetch["Employee Classification"],
  //     };

  //     let EmployeeGradeObj = {
  //       id: props.editdatafetch["Employee Category ID"],
  //       value: props.editdatafetch["Employee Category ID"],
  //       label: props.editdatafetch["Employee Category"],
  //     };
  //     let departmentObj = {
  //       id: props.editdatafetch["Department ID"],
  //       value: props.editdatafetch["Department ID"],
  //       label: props.editdatafetch["Department"],
  //     };
  //     let countryObj = {
  //       id: props.editdatafetch["Permanent Country ID"],
  //       value: props.editdatafetch["Permanent Country ID"],
  //       label: props.editdatafetch["Permanent Country"],
  //     };
  //     let stateObj = {
  //       id: props.editdatafetch["Permanent State ID"],
  //       value: props.editdatafetch["Permanent State ID"],
  //       label: props.editdatafetch["Permanent State"],
  //     };
  //     let districtObj = {
  //       id: props.editdatafetch["Permanent District ID"],
  //       value: props.editdatafetch["Permanent District ID"],
  //       label: props.editdatafetch["Permanent District"],
  //     };
  //     let cityObj = {
  //       id: props.editdatafetch["Permanent City ID"],
  //       value: props.editdatafetch["Permanent City ID"],
  //       label: props.editdatafetch["Permanent City"],
  //     };
  //     let areaObj = {
  //       id: props.editdatafetch["Permanent Area ID"],
  //       value: props.editdatafetch["Permanent Area ID"],
  //       label: props.editdatafetch["Permanent Area"],
  //     };
  //     let localCountryObj = {
  //       id: props.editdatafetch["Local Country ID"],
  //       value: props.editdatafetch["Local Country ID"],
  //       label: props.editdatafetch["Local Country"],
  //     };
  //     let localStateObj = {
  //       id: props.editdatafetch["Local State ID"],
  //       value: props.editdatafetch["Local State ID"],
  //       label: props.editdatafetch["Local State"],
  //     };
  //     let localDistrictObj = {
  //       id: props.editdatafetch["Local District ID"],
  //       value: props.editdatafetch["Local District ID"],
  //       label: props.editdatafetch["Local District"],
  //     };

  //     let localCityObj = {
  //       id: props.editdatafetch["Local City ID"],
  //       value: props.editdatafetch["Local City ID"],
  //       label: props.editdatafetch["Local City"],
  //     };
  //     let localAreaObj = {
  //       id: props.editdatafetch["Local Area ID"],
  //       value: props.editdatafetch["Local Area ID"],
  //       label: props.editdatafetch["Local Area"],
  //     };
  //     let BankNameObj = {
  //       id: props.editdatafetch["Bank Name ID"],
  //       value: props.editdatafetch["Bank Name ID"],
  //       label: props.editdatafetch["Bank Name"],
  //     };
  //     let salaryModeObj = {
  //       id: props.editdatafetch["Salary Mode"],
  //       value: props.editdatafetch["Salary Mode"],
  //       label: salaryModeWatch?.label,
  //     };
  //     // setValue("unit",unitObj)
  //     setValue("employeeCode", props.editdatafetch["Code"]);

  //     setValue("status", Status);
  //     setValue("prefix", prefixObj);
  //     setValue("firstName", props.editdatafetch["First Name"]);
  //     setValue("middleName", props.editdatafetch["Middle Name"]);
  //     setValue("lastName", props.editdatafetch["Last Name"]);
  //     let rawDOB = props.editdatafetch["Birth Date"];

  //     let dateofBirth = rawDOB
  //       ? new Date(rawDOB.toString().replaceAll("+00:00", ""))
  //       : null;

  //     setValue("dateofBirth", dateofBirth);
  //     // setDateOfBirth(dateofBirth);
  //     setValue("dateofBirth", dateofBirth);
  //     setValue("religion", religionObj);
  //     setValue("motherTongh", motherTonghObj);
  //     setValue("bloodGroup", bloodGroupObj);
  //     setValue("maritalStatus", maritalStatusObj);
  //     setValue("panNo", props.editdatafetch["PAN No"]);
  //     setValue("telephoneNo", props.editdatafetch["Tel No"]);
  //     setValue("mobileNo", props.editdatafetch["Mobile No"]);
  //     setValue("emailID", props.editdatafetch["Email ID"]);
  //     setValue("passportNo", props.editdatafetch["Passport No"]);
  //     setValue("designation", designationObj);
  //     setValue("EmployeeType", EmployeeTypeObj);
  //     setValue("employeeGrade", EmployeeGradeObj);
  //     let rawAnniversary = props.editdatafetch["Date of Anniversary"];
  //     let dateOfAnniversary = rawAnniversary
  //       ? new Date(rawAnniversary.toString().replaceAll("+00:00", ""))
  //       : null;

  //     let rawJoining = props.editdatafetch["Date Of Joining"];
  //     let dateOfJoining = rawJoining
  //       ? new Date(rawJoining.toString().replaceAll("+00:00", ""))
  //       : null;

  //     setValue("department", departmentObj);
  //     setValue("PFNo", props.editdatafetch["PF No"]);
  //     setValue("eSINo", props.editdatafetch["ESI No"]);
  //     setValue("address", props.editdatafetch["Permanent Address"]);
  //     setValue("country", countryObj);
  //     setValue("state", stateObj);
  //     setValue("district", districtObj);
  //     setValue("city", cityObj);
  //     setValue("area", areaObj);
  //     setValue("localaddress", props.editdatafetch["Local Address"]);
  //     setValue("localCountry", localCountryObj);
  //     setValue("localState", localStateObj);
  //     setValue("localDistrict", localDistrictObj);
  //     setValue("localCity", localCityObj);
  //     setValue("localArea", localAreaObj);
  //     setValue("localPinCode", props.editdatafetch["Local PIN"]);
  //     setValue("pinCode", props.editdatafetch["Permanent PIN"]);
  //     let eduArr = props.editdatafetch.empEducation;
  //     if (eduArr !== undefined && eduArr?.length > 0) {
  //       let EducationArr = [];
  //       for (let i = 0; i < eduArr?.length; i++) {
  //         let obj = {
  //           qualificationId: eduArr[i]["QualificationId"],
  //           qualificationDec: eduArr[i]["Qualification"],
  //           yearPassing: eduArr[i]["Yeas of Passing"],
  //           university: eduArr[i]["University"],
  //           classOrMarks: eduArr[i]["Class"],
  //           printApplicable: eduArr[i]["Print Applicable"],
  //           educationId: eduArr[i]["educationId"],
  //         };
  //         EducationArr.push(obj);
  //         setEduData(EducationArr);
  //       }
  //     }
  //     let dependentArr = props.editdatafetch.empDependentDetails;
  //     if (dependentArr !== undefined && dependentArr?.length > 0) {
  //       let Applibility;
  //       if (dependentArr["Applibility"] !== "Y") {
  //         Applibility = true;
  //       } else if (dependentArr["Applibility"] !== "N") {
  //         Applibility = false;
  //       }

  //       let newdepArr = [];
  //       for (let i = 0; i < dependentArr?.length; i++) {
  //         let birthDateDep = new Date(dependentArr[i]["Birth Date"]);

  //         let birdthDat = format(birthDateDep, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

  //         let obj = {
  //           firstName: dependentArr[i]["First Name"],
  //           middleName: dependentArr[i]["Middle Name"],
  //           lastName: dependentArr[i]["Last Name"],
  //           // sexId: dependentGenderWatch.id,
  //           // sexDec:dependentGenderWatch.label,
  //           birthDate: birthDateDep,
  //           age: dependentArr[i]["Age"],
  //           relationId: dependentArr[i]["RelationId"],
  //           relationDec: dependentArr[i]["Relation"],
  //           occupationId: dependentArr[i]["OccupationId"],
  //           occupationDecs: dependentArr[i]["Occupation"],
  //           sexId: dependentArr[i]["GenderId"],
  //           sexDec: dependentArr[i]["Gender"],
  //           dependentId: dependentArr[i]["DependentId"],
  //           applicability: Applibility,
  //         };
  //         newdepArr.push(obj);

  //         setDependentData(newdepArr);
  //       }
  //     }
  //     let expArr = props.editdatafetch.empExperienceDetails;
  //     if (expArr !== undefined && expArr?.length > 0) {
  //       let newExpArr = [];
  //       for (let i = 0; i < expArr?.length; i++) {
  //         let obj = {
  //           fromDate: expArr[i]["From Date"],
  //           toDate: expArr[i]["To Date"],
  //           expYear: expArr[i]["Experience Years"],
  //           expMonth: expArr[i]["Experience Months"],
  //           lastDrawnSalary: expArr[i]["Last Drawn Salary"],
  //           postHeld: expArr[i]["Post Held"],
  //           company: expArr[i]["Company"],
  //           reasonForLeaving: expArr[i]["Reason For Leaving"],
  //           experienceId: expArr[i]["Employee ID"],
  //         };

  //         newExpArr.push(obj);

  //         setExperienceData(newExpArr);
  //       }
  //     }

  //     let refArr = props.editdatafetch.empReference;
  //     console.log("refArr", refArr);
  //     if (refArr !== undefined && refArr?.length > 0) {
  //       let newRefArr = [];
  //       for (let i = 0; i < refArr?.length; i++) {
  //         let obj = {
  //           address: refArr[i]["Address"],
  //           positionHold: refArr[i]["Position Hold"],
  //           employeeName: refArr[i]["Employee Name"],
  //           company: refArr[i]["Company"],
  //           referenceId: refArr[i]["ReferenceId"],
  //         };

  //         newRefArr.push(obj);
  //         setReferenceData(newRefArr);
  //       }
  //     }

  //     // let empBenefitsArr = props.editdatafetch.empBenefits;
  //     let empBenefitsArr = props?.editdatafetch?.empBenefits ?? {};
  //     // let benefitHistory = empBenefitsArr?.["Previous History Table"];
  //     let benefitHistory = Array.isArray(empBenefitsArr?.["Previous History Table"])
  //       ? empBenefitsArr["Previous History Table"]
  //       : [];

  //     console.log(
  //       "props.editdatafetch00",
  //       // props.editdatafetch.empBenefits["Previous History Table"]
  //       props.editdatafetch?.["Previous History Table"] || []
  //     );
  //     let fromDateEmp = props?.editdatafetch?.empBenefits?.["From Date"]
  //       ? new Date(props.editdatafetch.empBenefits["From Date"])
  //       : null;
  //     setValue("fromDateEmp", fromDateEmp);
  //     // setFromToDateEmp(fromDateEmp);

  //     let toDateEmp = props?.editdatafetch?.empBenefits?.["To Date"]
  //       ? new Date(props.editdatafetch.empBenefits["To Date"])
  //       : null;

  //     setValue("toDateEmp", toDateEmp);
  //     let newBef = [];
  //     for (let obj of benefitHistory) {
  //       console.log("objBef", obj);
  //       let objOfBenef = {
  //         Year: obj["year"],
  //         IPDAmount: obj["IPD Amount"],
  //         OPDAmount: obj["OPD Amount"],
  //         IPDBalanceAmount: obj["IPD Balance Amt"],
  //         OPDBalanceAmount: obj["OPD Balance Amt"],
  //         PharmacyAmount: obj["Pharmacy Amount"],
  //         PharmacyBalanceAmount: obj["Pharmacy Balance Amt"],
  //       };

  //       newBef.push(objOfBenef);
  //     }

  //     setEmpBenefitHistory(newBef);

  //     let Temp = [...EmployeeBenefitsData];

  //     for (let i = 0; i < Temp?.length; i++) {
  //       console.log("EmployeeBenefitsData", Temp);
  //       if (Temp[i]?.Group === "OPD") {
  //         Temp[i].AmountPerYear = empBenefitsArr?.["OPD Amount"] || ""

  //         Temp[i].BalanceAmt = empBenefitsArr["OPD Balance Amt"];
  //       }
  //       if (Temp[i]?.Group === "IPD") {
  //         Temp[i].AmountPerYear = empBenefitsArr["Ipd Amount"];

  //         Temp[i].BalanceAmt = empBenefitsArr["IPD Balance Amt"];
  //       }
  //       if (Temp[i]?.Group === "Pharmacy") {
  //         Temp[i].AmountPerYear = empBenefitsArr["Pharmacy Amount"];

  //         Temp[i].BalanceAmt = empBenefitsArr["Pharmacy Balance Amt"];
  //       }
  //     }

  //     setValue("BankName", BankNameObj);
  //     setValue("branchName", props.editdatafetch["Bank Branch Name"]);
  //     setValue("ACNo", props.editdatafetch["Bank Account No"]);
  //     if (props.editdatafetch["Account Type"] === "C") {
  //       setValue("accountType", "current");
  //     } else if (props.editdatafetch["Account Type"] === "S") {
  //       setValue("accountType", "saving");
  //     }
  //     setValue("accessCardNo", props.editdatafetch["Access Card No"]);
  //     setValue("extensionNo", props.editdatafetch["Extension"]);
  //     // let issueDate = new Date(
  //     //   props.editdatafetch["Passport Issue Date"]
  //     //     // .toString()
  //     //     .toLocaleDateString()
  //     //     .replaceAll("+00:00", "")
  //     // );
  //     // setIssueDate(issueDate);
  //     // let expiryDate = new Date(
  //     //   props.editdatafetch["Passport Expiry Date"]
  //     //     // .toString()
  //     //     .toLocaleDateString()
  //     //     .replaceAll("+00:00", "")
  //     // );
  //     // setExpiryDate(expiryDate);
  //     // setValue("issuePlace", props.editdatafetch["Passport Issue Place"]);
  //     // let regDate = new Date(
  //     //   props.editdatafetch["Resignation Date"]
  //     //     // .toString()
  //     //     .toLocaleDateString()
  //     //     .replaceAll("+00:00", "")
  //     // );
  //     // setRegDate(regDate);
  //     // let lastWorking = new Date(
  //     //   props.editdatafetch["Last Working Date"]
  //     //     // .toString()
  //     //     .toLocaleDateString()
  //     //     .replaceAll("+00:00", "")
  //     // );
  //     // setLastWorking(lastWorking);


  //     const parseDateSafe = (dateStr) => {
  //       if (!dateStr) return null;

  //       if (dateStr.startsWith("1900-01-01")) return null;

  //       const [datePart] = dateStr.split("T");
  //       const [year, month, day] = datePart.split("-");

  //       const parsed = new Date(year, month - 1, day);

  //       return isNaN(parsed.getTime()) ? null : parsed;
  //     };

  //     let issueDate = parseDateSafe(
  //       props.editdatafetch?.["Passport Issue Date"]
  //     );
  //     setIssueDate(issueDate);

  //     let expiryDate = parseDateSafe(
  //       props.editdatafetch?.["Passport Expiry Date"]
  //     );
  //     setExpiryDate(expiryDate);

  //     setValue(
  //       "issuePlace",
  //       props.editdatafetch?.["Passport Issue Place"] || ""
  //     );

  //     let regDate = parseDateSafe(
  //       props.editdatafetch?.["Resignation Date"]
  //     );
  //     setRegDate(regDate);

  //     let lastWorking = parseDateSafe(
  //       props.editdatafetch?.["Last Working Date"]
  //     );
  //     setLastWorking(lastWorking);

  //     setValue("salaryMode", salaryModeObj);

  //     // salaryModeObj
  //     setValue("resignReason", props.editdatafetch["Resignation Reason"]);
  //   }
  // }, [props.editdatafetch]);


  useEffect(() => {
    if (props.edit === false && props.open) {
      reset(defaultValues);   // ✅ CLEAR FORM FOR ADD NEW
    }
  }, [props.open, props.edit]);

  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  };


  useEffect(() => {
    if (props.edit === true && props.editdatafetch) {
      const data = props.editdatafetch;

      setValue("EmployeeType", data.empClassification ? {
        label: data.empClassification,
        value: data.empClassification
      } : null);

      setValue("employeeGrade", data.empCategory ? {
        label: data.empCategory,
        value: data.empCategory
      } : null);

      setValue(
        "accountType",
        data.accountType === "S" ? "saving" :
          data.accountType === "C" ? "current" : ""
      );
      // setValue("active", data.active ?? false);

      setValue("status", data.active ?? false);

      setValue("firstName", data.firstName);
      setValue("middleName", data.middleName);
      setValue("lastName", data.lastName);

      // dropdown mapping
      setValue("prefix", data.prefix ? {
        label: data.prefix,
        value: data.prefix
      } : null);

      setValue("religion", data.religion ? {
        label: data.religion,
        value: data.religion
      } : null);

      setValue("motherTongh", data.motherTongue ? {
        label: data.motherTongue,
        value: data.motherTongue
      } : null);

      setValue("designation", data.designation?.trim() ? {
        label: data.designation,
        value: data.designation
      } : null);

      setValue("department", data.department ? {
        label: data.department,
        value: data.department
      } : null);

      setValue("bloodGroup", data.bloodGroup ? {
        label: data.bloodGroup,
        value: data.bloodGroup
      } : null);

      setValue("maritalStatus", data.maritalStatus ? {
        label: data.maritalStatus,
        value: data.maritalStatus
      } : null);

      setValue("PFNo", data.pfnumber ?? "");
      setValue("eSINo", data.esinumber ?? "");

      // dropdowns
      setValue("country", data.pcountry ? {
        label: data.pcountry,
        value: data.pcountry
      } : null);

      setValue("state", data.pstate ? {
        label: data.pstate,
        value: data.pstate
      } : null);

      setValue("district", data.pdistrict ? {
        label: data.pdistrict,
        value: data.pdistrict
      } : null);

      setValue("city", data.pcity ? {
        label: data.pcity,
        value: data.pcity
      } : null);

      setValue("area", data.parea ? {
        label: data.parea,
        value: data.parea
      } : null);


      setValue("BankName", data.bankName ? {
        label: data.bankName,
        value: data.bankName
      } : null);

      setValue("branchName", data.branchName || "");
      setValue("ACNo", data.accountNo || "");
      setValue("IFSCCode", data.IFSCCode || "");


      // dropdown
      setValue("salaryMode", data.salaryMode ? {
        label: data.salaryMode,
        value: data.salaryMode
      } : null);

      setValue("localaddress", data.laddress || "");

      setValue("localCountry", data.lcountry ? {
        label: data.lcountry,
        value: data.lcountry
      } : null);

      setValue("localDistrict", data.ldistrict ? {
        label: data.ldistrict,
        value: data.ldistrict
      } : null);

      setValue("localState", data.lstate ? {
        label: data.lstate,
        value: data.lstate
      } : null);

      setValue("localCity", data.lcity ? {
        label: data.lcity,
        value: data.lcity
      } : null);

      setValue("localArea", data.larea ? {
        label: data.larea,
        value: data.larea
      } : null);

      setValue("localPinCode", data.lpinCode || "");

      setValue("accessCardNo", data.acessCardNo || "");
      setValue("extensionNo", data.extension || "");

      // reportingTo (dropdown)
      setValue("reportingTo", data.reportingTo ? {
        label: data.reportingTo.trim(),
        value: data.reportingTo.trim()
      } : null);

      setValue("passportNo", data.passportNo || "");
      setValue("issuePlace", data.passportIssuePlace || "");

      // setValue("issueDate",
      //   data.passportIssuedate ? new Date(data.passportIssuedate) : null
      // );

      // setValue("expiryDate",
      //   data.resignationDt ? new Date(data.resignationDt) : null
      // );

      // setValue("regDate",
      //   data.resignationDt ? new Date(data.resignationDt) : null
      // );

      // setValue("lastWorking",
      //   data.lastWorkingDate ? new Date(data.lastWorkingDate) : null
      // );

      setIssueDate(parseDate(props.editdatafetch.passportIssuedate));
      setExpiryDate(parseDate(props.editdatafetch.passportExpirydate));
      setLastWorking(parseDate(props.editdatafetch.lastWorkingDate));
      setRegDate(parseDate(props.editdatafetch.resignationDt));


      setValue("resignReason", data.resignReason || "");

      setValue("yy", data.ageYear ?? "");
      setValue("mm", data.ageMonth ?? "");
      setValue("dd", data.ageDays ?? "");

      setValue("telephone", data.telephoneNo ?? "");

      // simple field
      setValue("pinCode", data.ppinCode || "");

      // dates
      setValue("dateofBirth",
        data.dateOfBirth ? new Date(data.dateOfBirth) : null
      );

      setValue("dateOfJoining",
        data.dateOfJoining ? new Date(data.dateOfJoining) : null
      );

      setValue("dateOfAnniversary",
        data.dateOfAnniversary ? new Date(data.dateOfAnniversary) : null
      );

      // simple fields
      setValue("mobileNo", data.mobileNo || "");
      setValue("emailID", data.emailId || "");
      setValue("panNo", data.panNo || "");

      // address
      setValue("address", data.paddress || "");

    }
  }, [props.editdatafetch]);

  const renderInput = (row, index) => {
    const handleInputChange = (row, index, e) => {
      let tempData = [...EmployeeBenefitsData];
      tempData[index].AmountPerYear = e.target.value;
      // tempData = EmployeeBenefitsData;
    };

    return (
      <div className="flex ">
        <input
          type="number"
          defaultValue={row.AmountPerYear}
          className="border border-gray-500 rounded"
          onChange={(e) => {
            handleInputChange(row, index, e);
          }}
          name={`amt${index}`}
        />
      </div>
    );
  };

  return (
    <div>
      {" "}
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle}>
          <CancelPresentationIconButton
            onClick={() => {
              //   reset(defaultValues);
              props.handleClose();
              //   props.setEdit(false);
            }}
          />
          <Box
            sx={{
              "&::-webkit-scrollbar": {
                width: 7,
                height: 10,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#7393B3",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "lightBlue",
              },
            }}
            className="h-[600px] overflow-auto"
          >
            <form onSubmit={handleSubmit(onSubmitDataHandler)}>
              <fieldset className=" text-left  py-2 rounded mt-1  p-3">
                <legend className=" px-2 ml-3 lg:ml-0  text-gray-800 text-[18px] font-semibold text-start ">
                  Employee
                </legend>

                <div className="">
                  <div>
                    <fieldset>
                      <div className="w-full my-1">
                        <Accordion
                          className="px-2"
                          sx={{
                            "& .MuiAccordionSummary-root": {
                              padding: "0px",
                              // marginBottom: "-1rem",
                            },

                            "& .MuiAccordionDetails-root": {
                              padding: "0px",
                            },
                            boxShadow: 1,
                          }}
                          defaultExpanded={true}
                        >
                          <AccordionSummary
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            expandIcon={
                              <ExpandMoreIcon
                              // sx={{
                              //   background: "#0B83A5",
                              //   margin: "5px 0",
                              //   color: "white",
                              //   minHeight: 0,
                              // }}
                              />
                            }
                            sx={{
                              "&.Mui-expanded": {
                                minHeight: 1,
                              },
                              "& .MuiAccordionSummary-content.Mui-expanded": {
                                margin: "auto",
                              },
                              "&.expanded": {
                                margin: "0px",
                              },
                            }}
                          >
                            <p className="text-start text-[16px] font-semibold pt-2 ">
                              Employee
                            </p>
                          </AccordionSummary>
                          <div className="grid lg:grid-cols-4 gap-3 md:grid-cols-3 pb-2">

                            {/* <div className="col-span-2 grid grid-cols-4 gap-3">
                              <div className="col-span-3">
                                <SearchDropdown
                                  control={control}
                                  name="searchDoctor"
                                  placeholder=" Search By Doctor"
                                  handleInputChange={handleChanges}
                                  dataArray={doctorOption}
                                  searchIcon={true}
                                  isDisabled={isDoctorWatch === false}
                                  inputRef={{
                                    ...register("searchDoctor", {
                                      onChange: (e) => {
                                        setDoctorId(e.target.value.id);

                                        doctorDetail(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                              <div className="col-span-1">
                                <CheckBoxField
                                  control={control}
                                  label="Is Doctor"
                                  name="isDoctor"
                                />
                              </div>
                            </div> */}
                            {/* 
                            <div>
                              <DropdownField
                                control={control}
                                name="unit"
                                placeholder="Unit*"
                                isMulti={true}
                                dataArray={unitOption}
                              />
                            </div> */}

                            <div className="flex gap-2">
                              <CheckBoxField
                                control={control}
                                label="Active"
                                name="status"
                              />

                              <DropdownField
                                control={control}
                                name="prefix"
                                placeholder="Prefix"
                                sx={{ width: "100px" }}
                                dataArray={prefixOption}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="firstName"
                                label="Frist Name*"
                                error={errors.firstName}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="middleName"
                                label="Middle Name"
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="lastName"
                                label="Last Name*"
                                error={errors.lastName}
                              />
                            </div>

                            <div>
                              <DatePickerField
                                control={control}
                                name="dateofBirth"
                                label="Date Of Birth"
                                disableFuture
                                // value={dateofBirth}
                                // onChange={(newValue) => {
                                //   console.log(
                                //     "selected date onchange",
                                //     newValue
                                //   );
                                //   setDateOfBirth(newValue);
                                // }}
                                inputFormat="dd/MM/yyyy"
                                onAccept={(e) => {
                                  getAgeDOB(e);
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                            </div>

                            <div className="grid grid-cols-3  gap-3">
                              <InputField
                                control={control}
                                name="yy"
                                label="YY"
                              />
                              <InputField
                                control={control}
                                name="mm"
                                label="MM"
                              />
                              <InputField
                                control={control}
                                name="dd"
                                label="DD"
                              />
                            </div>

                            <div className="flex gap-2">
                              <DropdownField
                                control={control}
                                name="religion"
                                placeholder="Religion"
                                dataArray={religionOption}
                              />
                              <DropdownField
                                control={control}
                                name="motherTongh"
                                placeholder="Mother Tongh"
                                dataArray={motherTonghOption}
                              />
                            </div>
                            <div className="flex gap-2">
                              <DropdownField
                                control={control}
                                name="bloodGroup"
                                placeholder="Blood Group"
                                dataArray={bloodGroupOption}
                              />
                              <DropdownField
                                control={control}
                                name="maritalStatus"
                                placeholder="Marital Status"
                                dataArray={maritalStatusOption}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="panNo"
                                label="Pan No"
                                error={errors.panNo}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                // name="telephoneNo"
                                name="telephone"
                                label="Telephone No."
                              />
                            </div>

                            <div>
                              <InputLimit
                                control={control}
                                name="mobileNo"
                                label="Mobile No."
                                maxDigits={10}
                                error={errors.mobileNo}
                              // disabled={props.status === "view"}
                              // color={customMobError ? "error" : "primary"}
                              // sx={{
                              //   input: {
                              //     color: customMobError
                              //       ? "#070708"
                              //       : "#121212",
                              //   },
                              //   label: {
                              //     color: customMobError
                              //       ? "#d32f2f"
                              //       : "#63686e",
                              //   },
                              // }}
                              // inputRef={{
                              //   ...register("mobileNumber", {
                              //     onChange: (e) => {
                              //       let text = e.target.value;
                              //       if (
                              //         text.length < 10 ||
                              //         text.length > 14
                              //       ) {
                              //         setMobCustomError(true);
                              //       } else {
                              //         setMobCustomError(false);
                              //       }
                              //     },
                              //   }),
                              // }}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="emailID"
                                label="Email ID"
                                dontCapitalize
                                error={errors.emailID}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="designation"
                                placeholder="Designation"
                                dataArray={designationOption}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="EmployeeType"
                                placeholder="Employee Classification - Type"
                                dataArray={classificationOption}
                                inputRef={{
                                  ...register("EmployeeType", {
                                    onChange: (e) => {
                                      setClassificationId(e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="employeeGrade"
                                placeholder="Employee Category - Grade"
                                dataArray={categoryOption}
                                inputRef={{
                                  ...register("employeeGrade", {
                                    onChange: (e) => {
                                      setCategoryId(e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div className="grid grid-cols-2 gap-2">
                              <DatePickerField
                                control={control}
                                name="dateOfAnniversary"
                                label="Date Of Anniversary"
                                disableFuture
                                // value={dateofBirth}
                                // onChange={(newValue) => {
                                //   console.log(
                                //     "selected date onchange",
                                //     newValue
                                //   );
                                //   setDateOfBirth(newValue);
                                // }}
                                inputFormat="dd/MM/yyyy"
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                              <DatePickerField
                                control={control}
                                name="dateOfJoining"
                                label="Date Of Joining"
                                disableFuture
                                // value={dateofBirth}
                                // onChange={(newValue) => {
                                //   console.log(
                                //     "selected date onchange",
                                //     newValue
                                //   );
                                //   setDateOfBirth(newValue);
                                // }}
                                inputFormat="dd/MM/yyyy"
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                            </div>

                            <div>
                              <SearchDropdown
                                control={control}
                                name="department"
                                placeholder="Department"
                                isClearable={true}
                                handleInputChange={handleChangesDeparment}
                                dataArray={departmentOption}
                                onChange={(selected) => {
                                  setDepartmentId(selected?.id || selected?.value || null);
                                }}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="PFNo"
                                label="PF. No"
                                error={errors.PFNo}
                              //   dataArray={EmployeeTypeOption}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="eSINo"
                                label="ESI No."
                                error={errors.eSINo}
                              //   dataArray={specializationOption}
                              />
                            </div>
                          </div>
                        </Accordion>
                      </div>
                    </fieldset>
                  </div>

                  <div>
                    <fieldset>
                      <div className="w-full my-1 ">
                        <Accordion
                          className="px-2  "
                          sx={{
                            "& .MuiAccordionSummary-root": {
                              padding: "0px",
                              // marginBottom: "-1rem",
                            },

                            "& .MuiAccordionDetails-root": {
                              padding: "0px",
                            },
                            boxShadow: 1,
                          }}
                          defaultExpanded={true}
                        >
                          <AccordionSummary
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            expandIcon={
                              <ExpandMoreIcon
                              // sx={{
                              //   background: "#0B83A5",
                              //   margin: "5px 0",
                              //   color: "white",
                              //   minHeight: 0,
                              // }}
                              />
                            }
                            sx={{
                              "&.Mui-expanded": {
                                minHeight: 1,
                              },
                              "& .MuiAccordionSummary-content.Mui-expanded": {
                                margin: "auto",
                              },
                              "&.expanded": {
                                margin: "0px",
                              },
                            }}
                          >
                            <p className="text-start text-[16px] font-semibold pt-2">
                              Address Detail
                            </p>
                          </AccordionSummary>
                          <div>
                            <div className="py-2">
                              <label className="text-[17px] font-semibold ">
                                Permeant Address{" "}
                              </label>
                            </div>
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3  pb-2">
                              <div className="col-span-2">
                                <InputField
                                  control={control}
                                  name="address"
                                  label="Address*"
                                  error={errors.address}
                                />
                              </div>
                              <div>
                                <DropdownField
                                  control={control}
                                  name="country"
                                  placeholder="Country"
                                  dataArray={countryOption}
                                  inputRef={{
                                    ...register("country", {
                                      onChange: (e) => {
                                        setCountryId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                              <div>
                                <DropdownField
                                  control={control}
                                  name="state"
                                  placeholder="State"
                                  dataArray={stateOption}
                                  inputRef={{
                                    ...register("state", {
                                      onChange: (e) => {
                                        setStateId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>

                              <div>
                                <DropdownField
                                  control={control}
                                  name="district"
                                  placeholder="District"
                                  dataArray={districtOption}
                                  inputRef={{
                                    ...register("district", {
                                      onChange: (e) => {
                                        setDistrictId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>

                              <div>
                                <DropdownField
                                  control={control}
                                  name="city"
                                  placeholder="City"
                                  dataArray={cityOption}
                                  inputRef={{
                                    ...register("city", {
                                      onChange: (e) => {
                                        setCityId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                              <div>
                                <DropdownField
                                  control={control}
                                  name="area"
                                  placeholder="Area"
                                  dataArray={areaOption}
                                />
                              </div>
                              <div>
                                <InputLimit
                                  maxDigits={6}
                                  control={control}
                                  name="pinCode"
                                  label="Pin Code"
                                  error={errors.pinCode}
                                />
                              </div>
                            </div>
                            <div className="flex gap-2">
                              <label className="text-[13px] font-semibold pt-2">
                                Local Address{" "}
                              </label>
                              <CheckBoxField
                                control={control}
                                name="addresslocal"
                                label="Same as per permeant address"
                                // onClick={
                                //   handleCheckSubmit()
                                // }
                                inputRef={{
                                  ...register("addresslocal", {
                                    onChange: (e) => {
                                      handleCheckSubmit(e);
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 py-1">
                              <div className="col-span-2">
                                <InputField
                                  control={control}
                                  name="localaddress"
                                  label="Address *"
                                  error={errors.localaddress}
                                />
                              </div>
                              <div>
                                <DropdownField
                                  control={control}
                                  name="localCountry"
                                  dataArray={countryOption}
                                  placeholder="Country"
                                  inputRef={{
                                    ...register("localCountry", {
                                      onChange: (e) => {
                                        setCountryId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                              <div>
                                <DropdownField
                                  control={control}
                                  name="localState"
                                  placeholder="State"
                                  dataArray={stateOption}
                                  inputRef={{
                                    ...register("localState", {
                                      onChange: (e) => {
                                        setStateId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>

                              <div>
                                <DropdownField
                                  control={control}
                                  name="localDistrict"
                                  placeholder="District"
                                  dataArray={districtOption}
                                  inputRef={{
                                    ...register("localDistrict", {
                                      onChange: (e) => {
                                        setDistrictId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>

                              <div>
                                <DropdownField
                                  control={control}
                                  name="localCity"
                                  placeholder="City"
                                  dataArray={cityOption}
                                  inputRef={{
                                    ...register("localCity", {
                                      onChange: (e) => {
                                        setCityId(e.target.value.id);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                              <div>
                                <DropdownField
                                  control={control}
                                  name="localArea"
                                  placeholder="Area"
                                  dataArray={areaOption}
                                />
                              </div>
                              <div>
                                <InputLimit
                                  maxDigits={4}
                                  control={control}
                                  name="localPinCode"
                                  label="Pin Code"
                                  error={errors.localPinCode}
                                />
                              </div>
                            </div>
                          </div>
                        </Accordion>
                      </div>
                    </fieldset>
                  </div>

                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Education
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 pb-2">
                          <div className="flex gap-2">
                            <DropdownField
                              control={control}
                              name="degree"
                              placeholder="Degree*"
                              // dataArray={degreeOption}
                              dataArray={degreeArray}
                              error={errors.degree}
                            />
                            <InputLimit
                              maxDigits={4}
                              control={control}
                              name="yearofPassing"
                              label="Year of Passing "
                              className="appearance-none"
                              sx={{ width: "200px" }}
                              error={errors.yearofPassing}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="university"
                              label="University*"
                              error={errors.university}
                            />
                          </div>
                          <div className="flex gap-2 col-span-2">
                            <InputField
                              control={control}
                              name="classMarks"
                              label="Class/ Marks(%)"
                              sx={{ width: "200px" }}
                              error={errors.classMarks}
                            />
                            <CheckBoxField
                              control={control}
                              name="printApplicable"
                              label="Print Applicable"
                            />
                            <CommonButton
                              label="Add"
                              className="bg-green-500 text-white"
                              type="button"
                              onClick={() => {
                                handleEduOnSubmit();
                                handleReset();
                              }}
                            />
                          </div>
                        </div>

                        {eduData.length > 0 ? (
                          <CommonDynamicTableNew
                            dataResult={eduData}
                            highlightRow={false}
                            renderActions={RenderActions}
                            removeHeaders={[
                              "qualificationId",
                              "printApplicable",
                            ]}
                          />
                        ) : null}
                      </Accordion>
                    </div>
                  </fieldset>

                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Experience
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-2 ">
                          <div className="flex gap-2">
                            {/* <Controller
                              control={control}
                              name="fromDate"
                              rules={{
                                required: true,
                              }}
                              render={({ field }) => (
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DesktopDatePicker
                                    defaultValue={new Date()}
                                    disableFuture
                                    label="From Date"
                                    value={fromToDate}
                                    sx={{
                                      svg: {
                                        color: "#1E3A8A",
                                        height: 22,
                                        width: "100%",
                                        marginRight: "16px",
                                      },
                                      backgroundColor: "white",
                                      overflow: "visible",
                                      "& .MuiInputBase-root": {
                                        height: "35.2px",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "& .MuiOutlinedInput-input": {
                                          // border: 0,
                                          fontSize: 14,
                                          height: "5px",
                                          width: "100%",
                                          // color: "red",
                                          // background: "red",
                                          borderColor: "#ffffff",
                                          overflow: "hidden",
                                        },
                                        "& .MuiFormLabel-root": {
                                          fontSize: "14px",
                                        },
                                      },
                                    }}
                                    format="dd/MM/yyyy"
                                    onChange={(newValue) => {
                                      setFromToDate(newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        className="bg-white"
                                        name="fromDate"
                                        placeholder="From Date"
                                        fullWidth
                                        size="small"
                                        {...params}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              )}
                              
                            /> */}
                            <DatePickerField
                              control={control}
                              name="fromDate"
                              label="From Date"
                              disableFuture
                              // value={dateofBirth}
                              // onChange={(newValue) => {
                              //   console.log(
                              //     "selected date onchange",
                              //     newValue
                              //   );
                              //   setDateOfBirth(newValue);
                              // }}
                              inputFormat="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  size: "small",
                                  fullWidth: true,
                                  sx: commonDatePickerSx,
                                },
                              }}
                            />
                            <DatePickerField
                              control={control}
                              name="toDate"
                              label="To Date"
                              disableFuture
                              // value={dateofBirth}
                              // onChange={(newValue) => {
                              //   console.log(
                              //     "selected date onchange",
                              //     newValue
                              //   );
                              //   setDateOfBirth(newValue);
                              // }}
                              inputFormat="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  size: "small",
                                  fullWidth: true,
                                  sx: commonDatePickerSx,
                                },
                              }}
                            />
                          </div>

                          <div className="flex gap-2">
                            <InputField
                              control={control}
                              name="experienceyy"
                              label="YY"
                              sx={{ width: "80px" }}
                            />
                            <InputField
                              control={control}
                              name="experiencemm"
                              label="MM"
                              sx={{ width: "80px" }}
                            />
                            <InputField
                              control={control}
                              name="lastSalaryDrawn"
                              label="Last Salary Drawn"
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="postHeld"
                              label="Post Held*"
                              error={errors.postHeld}
                            />
                          </div>
                          <div className="">
                            <InputField
                              control={control}
                              name="company"
                              label="Company*"
                              error={errors.company}
                            />
                          </div>

                          <div className="">
                            <InputField
                              control={control}
                              name="reasonForleaving"
                              label="Reason For leaving"
                            />
                          </div>
                          <div>
                            <CommonButton
                              label="Add"
                              className="bg-green-500 text-white"
                              type="Button"
                              onClick={() => {
                                handleExperienceonSubmit();
                              }}
                            />
                          </div>
                        </div>
                        {experienceData.length > 0 ? (
                          <CommonDynamicTableNew
                            dataResult={experienceData}
                            highlightRow={false}
                            renderActions={RenderActionsExp}
                          // removeHeaders={["fromDate", "toDate"]}
                          />
                        ) : null}
                      </Accordion>
                    </div>
                  </fieldset>

                  <fieldset>
                    <div className="w-full my-1 pb-2 ">
                      <Accordion
                        className="px-2 "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2 ">
                            Employee Benefits
                          </p>
                        </AccordionSummary>

                        <div className="grid grid-cols-4 lg:grid-cols-4 pb-2  gap-2">
                          <div>
                            {/* <Controller
                              control={control}
                              name="fromDateEmp"
                              rules={{
                                required: true,
                              }}
                              render={({ field }) => (
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DesktopDatePicker
                                    defaultValue={new Date()}
                                    disableFuture
                                    label="From Date"
                                    value={fromToDateEmp}
                                    sx={{
                                      svg: {
                                        color: "#1E3A8A",
                                        height: 22,
                                        width: "100%",
                                        marginRight: "16px",
                                      },
                                      backgroundColor: "white",
                                      overflow: "visible",
                                      "& .MuiInputBase-root": {
                                        height: "35.2px",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "& .MuiOutlinedInput-input": {
                                          // border: 0,
                                          fontSize: 14,
                                          height: "5px",
                                          width: "100%",
                                          // color: "red",
                                          // background: "red",
                                          borderColor: "#ffffff",
                                          overflow: "hidden",
                                        },
                                        "& .MuiFormLabel-root": {
                                          fontSize: "14px",
                                        },
                                      },
                                    }}
                                    format="dd/MM/yyyy"
                                    onChange={(newValue) => {
                                      setFromToDateEmp(newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        className="bg-white"
                                        name="fromDateEmp"
                                        placeholder="From Date"
                                        fullWidth
                                        size="small"
                                        {...params}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              )}
                            /> */}

                            <DatePickerField
                              control={control}
                              name="fromDateEmp"
                              label="From Date"
                              disableFuture
                              // value={dateofBirth}
                              // onChange={(newValue) => {
                              //   console.log(
                              //     "selected date onchange",
                              //     newValue
                              //   );
                              //   setDateOfBirth(newValue);
                              // }}
                              inputFormat="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  size: "small",
                                  fullWidth: true,
                                  sx: commonDatePickerSx,
                                },
                              }}
                            />
                          </div>
                          <div>
                            <DatePickerField
                              control={control}
                              name="toDateEmp"
                              label="To Date"
                              disableFuture
                              // value={dateofBirth}
                              // onChange={(newValue) => {
                              //   console.log(
                              //     "selected date onchange",
                              //     newValue
                              //   );
                              //   setDateOfBirth(newValue);
                              // }}
                              inputFormat="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  size: "small",
                                  fullWidth: true,
                                  sx: commonDatePickerSx,
                                },
                              }}
                            />
                          </div>
                          <div className="col-span-2 flex justify-end">
                            <a
                              onClick={() => {
                                handleOpen();
                              }}
                            >
                              <Tooltip title="Histrory">
                                <History />
                              </Tooltip>
                            </a>
                          </div>
                          {/* {props.edit === true ? (
                            <EmployeeBenefitModel
                              open={open}
                              setOpen={setOpen}
                              handleClose={handleClose}
                              handleOpen={handleOpen}
                              empBenefitsHistory={empBenefitsHistory}
                            />
                          ) : null} */}
                        </div>

                        <CommonDynamicTableNew
                          dataResult={EmployeeBenefitsData}
                          editableColumns={["AmountPerYear"]}
                          renderInput={renderInput}
                        />
                      </Accordion>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="w-full my-1  ">
                      <Accordion
                        className="px-2 "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Dependent
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-3 lg:grid-cols-4 gap-3 pb-2 ">
                          <div>
                            <InputField
                              control={control}
                              name="dependentFirstName"
                              label="First Name*"
                              error={errors.dependentFirstName}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="dependentMiddleName"
                              label="Middle Name"
                              error={errors.dependentMiddleName}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="dependentLastName"
                              label="Last Name*"
                              error={errors.dependentLastName}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="dependentGender"
                              placeholder="Gender"
                              dataArray={genderOption}
                              error={errors.dependentGender}
                            />
                          </div>

                          <div className="flex gap-2">
                            {/* <Controller
                              control={control}
                              name="dateOfBirths"
                              rules={{
                                required: true,
                              }}
                              render={({ field }) => (
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DesktopDatePicker
                                    defaultValue={new Date()}
                                    label="Date Of Birth"
                                    disableFuture
                                    value={dateofBirths}
                                    sx={{
                                      svg: {
                                        color: "#1E3A8A",
                                        height: 22,
                                        width: "100%",
                                        marginRight: "16px",
                                      },
                                      backgroundColor: "white",
                                      overflow: "visible",
                                      "& .MuiInputBase-root": {
                                        height: "35.2px",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "& .MuiOutlinedInput-input": {
                                          // border: 0,
                                          fontSize: 14,
                                          height: "5px",
                                          width: "100%",
                                          // color: "red",
                                          // background: "red",
                                          borderColor: "#ffffff",
                                          overflow: "hidden",
                                        },
                                        "& .MuiFormLabel-root": {
                                          fontSize: "14px",
                                        },
                                      },
                                    }}
                                    format="dd/MM/yyyy"
                                    onChange={(newValue) => {
                                      setDateOfBirths(newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        className="bg-white"
                                        name="dateOfBirth"
                                        placeholder="Date Of Birth"
                                        fullWidth
                                        size="small"
                                        {...params}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              )}
                            /> */}
                            <DatePickerField
                              control={control}
                              name="dateOfBirths"
                              label="Birth Date"
                              disableFuture
                              // value={dateofBirth}
                              // onChange={(newValue) => {
                              //   console.log(
                              //     "selected date onchange",
                              //     newValue
                              //   );
                              //   setDateOfBirth(newValue);
                              // }}
                              inputFormat="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  size: "small",
                                  fullWidth: true,
                                  sx: commonDatePickerSx,
                                },
                              }}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              type="number"
                              name="dependentAge"
                              label="Age (Years)"
                              error={errors.dependentAge}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="dependentRelation"
                              placeholder="Relation"
                              dataArray={relationOption}
                              error={errors.dependentRelation}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="dependentOccupation"
                              placeholder="Occupation"
                              dataArray={occupationOption}
                              error={errors.dependentOccupation}
                            />
                          </div>

                          <div className=" gap-2 col-span-2">
                            <div className=" flex space-x-2 gap-2">
                              <label className="font-semibold text-[14px]">
                                Medical Allowance Applicability :
                              </label>
                              <RadioField
                                control={control}
                                name="Medical"
                                dataArray={MedicalAllowance}
                              />
                              <CommonButton
                                label="Add"
                                className="bg-green-500 text-white"
                                type="Button"
                                onClick={() => {
                                  handleDependentSubmit();
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {dependentData.length > 0 ? (
                          <CommonDynamicTableNew
                            dataResult={dependentData}
                            highlightRow={false}
                            renderActions={RenderActionsDep}
                            removeHeaders={[
                              "relationId",
                              "occupationId",
                              "sexId",
                              "birthDate",
                            ]}
                          />
                        ) : null}
                      </Accordion>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="w-full my-1  ">
                      <Accordion
                        className="px-2 "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Reference
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-3 lg:grid-cols-4 gap-3 pb-2 ">
                          <div>
                            <InputField
                              control={control}
                              name="employeeName"
                              label="Employee Name*"
                              error={errors.employeeName}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="companyName"
                              label="Company Name"
                              error={errors.companyName}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="positionHeld"
                              label="Position Held"
                              error={errors.positionHeld}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="referenceAddress"
                              label="Address"
                              error={errors.referenceAddress}
                            />
                          </div>

                          <CommonButton
                            label="Add"
                            className="bg-green-500 text-white"
                            type="button"
                            onClick={() => {
                              handleReference();
                              handleResetReferanance();
                            }}
                          />
                        </div>

                        {referenceData.length > 0 ? (
                          <CommonDynamicTableNew
                            dataResult={referenceData}
                            highlightRow={false}
                            renderActions={RenderActionsRefenace}
                          />
                        ) : null}
                      </Accordion>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Bank
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-3 lg:grid-cols-4 gap-2 pb-2">
                          <div>
                            <DropdownField
                              control={control}
                              name="BankName"
                              dataArray={bankOption}
                              placeholder="Bank Name"
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="branchName"
                              label="Branch Name"
                            />
                          </div>
                          <div>
                            <InputField
                              type="number"
                              control={control}
                              name="ACNo"
                              label="A/C No."
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="IFSCCode"
                              label="IFSC Code"
                              error={errors.IFSCCode}
                            />
                          </div>

                          <div>
                            <DropdownField
                              control={control}
                              name="salaryMode"
                              placeholder="Salary Mode"
                              dataArray={SalaryModeArr}
                            />
                          </div>

                          <div className="col-span-2 flex gap-2 pt-1">
                            <label className="font-semibold text-[14px]">
                              Account Type :
                            </label>
                            <RadioField
                              control={control}
                              name="accountType"
                              dataArray={accountType}
                            />
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold pt-2">
                            Other
                          </p>
                        </AccordionSummary>
                        <div>
                          <lable className="font-semibold text-[13px]">
                            Photo And Signature Upload {" "}
                          </lable>
                          <div className="grid grid-cols-2 lg:grid-cols-2 pb-[8px]">
                            <div className="flex gap-2 ">
                              {file ? (
                                <div>
                                  <CancelPresentationIconButton
                                    onClick={() => {
                                      setFile(null);   // ✅ FIX
                                    }}
                                  />
                                  <img
                                    src={file}
                                    key={resetKey}
                                    alt=""
                                    className="w-[120px] h-[120px]"
                                  />
                                </div>
                              ) : props.editdatafetch?.photoBase64 ? (
                                <img
                                  src={`data:image/png;base64,${props.editdatafetch.photoBase64}`}
                                  className="w-[120px] h-[120px]"
                                  alt=""
                                />
                              ) : (
                                <Photo />
                              )}
                              <div className="pt-10">
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) => handleChange(e)}
                                  ref={inputFile}
                                />
                              </div>
                            </div>

                            <div className="flex gap-2 ">
                              {uploadfile ? (
                                <div>
                                  <CancelPresentationIconButton
                                    onClick={() => {
                                      setUploadFile(null);
                                    }}
                                  />
                                  <img
                                    src={uploadfile}
                                    key={resetKey}
                                    className="w-[350px] h-[100px]"
                                    alt=""
                                  />
                                </div>
                              ) : props.editdatafetch?.signatureBase64 ? (
                                <img
                                  src={`data:image/png;base64,${props.editdatafetch.signatureBase64}`}
                                  className="w-[350px] h-[100px]"
                                  alt=""
                                />
                              ) : (
                                <Sign />
                              )}
                              <div className="pt-10">
                                <input
                                  type="file"
                                  onChange={(e) => handleChangeClick(e)}
                                  ref={inputFile}
                                />
                              </div>
                            </div>
                          </div>

                          <hr className="bg-blue-900"></hr>

                          <div className="grid grid-cols-3 lg:grid-cols-4 gap-2 pb-2 ">
                            <div>
                              <InputField
                                control={control}
                                name="accessCardNo"
                                label="Access Card No."
                                error={errors.accessCardNo}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="extensionNo"
                                label="Extension No."
                                error={errors.extensionNo}
                              />
                            </div>
                            <div>
                              <SearchDropdown
                                control={control}
                                name="reportingTo"
                                placeholder="Reporting  To. (Employee Dropdown)"
                                handleInputChange={handleChangesreportingTo}
                                isClearable={true}
                                error={errors.reportingTo}
                                dataArray={reportingToOption}
                                onChange={(selected) => {
                                  setreportingToId(selected?.id || selected?.value || null);
                                }}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="passportNo"
                                label="Passport No."
                                error={errors.passportNo}
                              />
                            </div>

                            <div>
                              <Controller
                                control={control}
                                name="issueDate"
                                rules={{
                                  required: true,
                                }}
                                render={({ field }) => (
                                  <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                  >
                                    <DesktopDatePicker
                                      defaultValue={new Date()}
                                      label="Issue Date"
                                      // value={issueDate}
                                      value={issueDate || null}
                                      onChange={(date) => setIssueDate(date)}
                                      format="dd/MM/yyyy"
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          fullWidth: true,
                                          sx: commonDatePickerSx,
                                        },
                                      }}
                                      // onChange={(newValue) => {
                                      //   setIssueDate(newValue);
                                      // }}
                                      renderInput={(params) => (
                                        <TextField
                                          className="bg-white"
                                          name="issueDate"
                                          placeholder="Issue Date"
                                          fullWidth
                                          // size="small"
                                          {...params}
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                )}
                              />
                            </div>
                            <div>
                              <Controller
                                control={control}
                                name="expiryDate"
                                rules={{
                                  required: true,
                                }}
                                render={({ field }) => (
                                  <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                  >
                                    <DesktopDatePicker
                                      defaultValue={new Date()}
                                      label="Expiry Date"
                                      // value={expiryDate}
                                      value={expiryDate || null}
                                      onChange={(date) => setExpiryDate(date)}
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          fullWidth: true,
                                          sx: commonDatePickerSx,
                                        },
                                      }}
                                      format="dd/MM/yyyy"
                                      // onChange={(newValue) => {
                                      //   setExpiryDate(newValue);
                                      // }}
                                      renderInput={(params) => (
                                        <TextField
                                          className="bg-white"
                                          name="expiryDate"
                                          placeholder="Expiry Date"
                                          fullWidth
                                          size="small"
                                          {...params}
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                )}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="issuePlace"
                                label="Issue Place"
                                error={errors.issuePlace}
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Resign Details
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 pb-2">
                          <div className="flex gap-2">
                            <Controller
                              control={control}
                              name="regDate"
                              rules={{
                                required: true,
                              }}
                              render={({ field }) => (
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DesktopDatePicker
                                    defaultValue={new Date()}
                                    label="Reg. Date"
                                    // value={regDate}
                                    value={regDate || null}
                                    onChange={(date) => setRegDate(date)}
                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        fullWidth: true,
                                        sx: commonDatePickerSx,
                                      },
                                    }}
                                    format="dd/MM/yyyy"
                                    // onChange={(newValue) => {
                                    //   setRegDate(newValue);
                                    // }}
                                    renderInput={(params) => (
                                      <TextField
                                        className="bg-white"
                                        name="regDate"
                                        placeholder="Reg. Date"
                                        fullWidth
                                        size="small"
                                        {...params}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              )}
                            />
                            <Controller
                              control={control}
                              name="lastWorking"
                              rules={{
                                required: true,
                              }}
                              render={({ field }) => (
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DesktopDatePicker
                                    defaultValue={new Date()}
                                    label="last Working "
                                    // value={lastworking}
                                    value={lastworking || null}
                                    onChange={(date) => setLastWorking(date)}
                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        fullWidth: true,
                                        sx: commonDatePickerSx,
                                      },
                                    }}
                                    format="dd/MM/yyyy"
                                    // onChange={(newValue) => {
                                    //   setLastWorking(newValue);
                                    // }}
                                    renderInput={(params) => (
                                      <TextField
                                        className="bg-white"
                                        name="lastWorking"
                                        placeholder="last Working "
                                        fullWidth
                                        size="small"
                                        {...params}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              )}
                            />
                          </div>
                          <div className="col-span-3">
                            <InputField
                              control={control}
                              name="resignReason"
                              label="Resign Reason"
                              error={errors.resignReason}
                            />
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>

                  {props.edit === false ? (
                    <div className="flex justify-end gap-2 pt-2">
                      <CommonButton
                        label="Reset"
                        className=" border border-red-600 text-red-600"
                        type="button"
                        onClick={() => reset(defaultValues)}
                      />
                      <CommonButton
                        label="Save"
                        className="bg-green-500 text-white"
                        type="Submit"
                        onClick={() => {
                          // handlElectricalDescriptionSubmit();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-end gap-2 pt-2">
                      <CommonButton
                        label="Save"
                        className="bg-green-500 text-white"
                        type="Update"
                        onClick={() => {
                          // handlElectricalDescriptionSubmit();
                        }}
                      />
                    </div>
                  )}
                </div>
              </fieldset>
            </form>
          </Box>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={handleClosePost}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to add this record ?"
        confirmationButtonMsg="Add"
      />
      <ConfirmationModal
        confirmationOpen={openPut}
        confirmationHandleClose={handleClosePut}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to update this record ?"
        confirmationButtonMsg="Update"
      />
    </div>
  );
}
